import AddIcon from '@mui/icons-material/AddCircle';
import ArticleIcon from '@mui/icons-material/Article';
import AssistantIcon from '@mui/icons-material/Assistant';
import ChatIcon from '@mui/icons-material/Chat';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Filter3Icon from '@mui/icons-material/Filter3';
import Filter7Icon from '@mui/icons-material/Filter7';
import InfoIcon from '@mui/icons-material/Info';
import MemoryIcon from '@mui/icons-material/Memory';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormHelperText, FormLabel, IconButton, Radio, RadioGroup, Tooltip, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid/Grid";
import TextField from "@mui/material/TextField/TextField";
import { useTheme } from "@mui/styles";
import Markdown from 'markdown-to-jsx';
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { ChangeEvent, MouseEvent, useEffect, useRef, useState } from "react";
import { WithContext as ReactTags } from 'react-tag-input';
import MaskedInput from "react-text-mask";
import * as Yup from 'yup';
import AttachmentPreviewBox from "../../../../components/AttachmentPreviewBox";
import CommentFormDialog from "../../../../components/CommentFormDialog";
import DatePicker from "../../../../components/DatePicker";
import DateTimePicker from "../../../../components/DateTimePicker";
import DefaultButton from "../../../../components/FormControl/DefaultButton";
import ErrorButton from "../../../../components/FormControl/ErrorButton";
import { FileInputButton } from "../../../../components/FormControl/FileInputButton";
import Form, { FormDirty, FormErrors, FormFooterAllButtons, FormValidationSchema } from "../../../../components/FormControl/Form/Form";
import FormDialog from '../../../../components/FormControl/FormDialog';
import OrangeButton from "../../../../components/FormControl/OrangeButton";
import MultiSelect, { MultiSelectOption } from '../../../../components/MultiSelect';
import Panel from "../../../../components/Panel/Panel";
import PanelBodyFormContent from "../../../../components/Panel/PanelBodyFormContent";
import { PopupWrapper } from "../../../../components/PopupWrapper";
import ReminderFormDialog from "../../../../components/ReminderFormDialog";
import SafeDeskTextEditor from '../../../../components/SafeDeskTextEditor';
import SelectSearch from "../../../../components/SelectSearch";
import OptionItem from "../../../../components/SelectSearch/OptionItem";
import SearchEntity from "../../../../components/SelectSearch/SearchEntity";
import { ServiceTimeCounter } from "../../../../components/ServiceTimeCounter";
import taskStatusChangeCommentDialog from "../../../../components/TaskStatusChangeCommentDialog";
import TextTemplateButtons from "../../../../components/TextTemplateButtons";
import TicketHistory, { TicketHistoryEventEmitterType } from "../../../../components/TicketHistory";
import AttachmentTaskType from "../../../../enum/AttachmentTaskType";
import CommentTaskType from "../../../../enum/CommentTaskType";
import ProductType from "../../../../enum/ProductType";
import SoftwareVersionStatus from "../../../../enum/SoftwareVersionStatus";
import SoftwareVersionType from "../../../../enum/SoftwareVersionType";
import TextTemplateType from "../../../../enum/TextTemplateType";
import UserAdminType from "../../../../enum/UserAdminType";
import UserType from "../../../../enum/UserType";
import AttachmentTask from "../../../../model/AttachmentTask";
import Checklist from "../../../../model/Checklist";
import ChecklistItem from "../../../../model/ChecklistItem";
import CommentTask from "../../../../model/CommentTask";
import CommentTaskUser from "../../../../model/CommentTaskUser";
import FinalCustomer from "../../../../model/FinalCustomer";
import FinalCustomerContract from "../../../../model/FinalCustomerContract";
import FinalCustomerContractProductLine from "../../../../enum/FinalCustomerContractProductLine";
import FinalCustomerContractServiceType from "../../../../enum/FinalCustomerContractServiceType";
import FinalCustomerContractStatus from "../../../../enum/FinalCustomerContractStatus";
import Project from "../../../../model/Project";
import ProductLine from "../../../../model/ProductLine";
import Software from "../../../../model/Software";
import Tag from "../../../../model/Tag";
import Task from "../../../../model/Task";
import TaskChecklist from "../../../../model/TaskChecklist";
import TaskChecklistItem from "../../../../model/TaskChecklistItem";
import TaskReminder from "../../../../model/TaskReminder";
import TicketCause from "../../../../model/TicketCause";
import TicketOrigin from "../../../../model/TicketOrigin";
import Product from "../../../../model/Product";
import TicketSolutionType from "../../../../model/TicketSolutionType";
import TicketStatus from "../../../../model/TicketStatus";
import TicketType from "../../../../model/TicketType";
import Integrator from "../../../../model/Integrator";
import User from "../../../../model/User";
import { useAlert } from '../../../../reducer/alertDialog';
import { useAuthentication } from "../../../../reducer/authentication";
import { useLoading } from "../../../../reducer/loading";
import { WhereCondition, downloadBlob } from "../../../../service/ServiceApi";
import { ServiceApi } from "../../../../service/ServiceApiWithLoading";
import TaskApi from "../../../../service/TaskApi";
import { convertFileByteToSizeString, formatCurrency, getUserDepartmentPermissions, getUserDepartmentsIds, objectClone, sortObjectArrayByProp } from "../../../../utils";
import EventEmitter from "../../../../utils/EventEmitter";
import FixedIds from '../../../../enum/FixedIds';
import TechnicalAssistance from '../../../../model/TechnicalAssistance';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import ListTextField from '../../../../components/ListTextField';
import { loadLastTechAssisBySeal } from '../../TechnicalAssistance/TechnicalAssistanceForm';
import Production from '../../../../model/Production';
import TableListPsim from '../../../../components/TableListPsim/TableListPsim';
import TicketStatusIcon from '../../../../components/TicketStatusIcon';
import { TicketLayoutTypeRule } from '../../Config/TicketLayoutTypes/TicketLayoutTypeForm';
import taskAddTagDialog from '../../../../components/TaskAddTagDialog';
import gitlabLogo from '../../../../images/gitlab_plain_logo_icon_146501.png';
import TagType from '../../../../enum/TagType';
import taskPauseCommentDialog from '../../../../components/TaskPauseCommentDialog';
import TicketRootCause from '../../../../model/TicketRootCause';

interface LastTechnicalAssistanceRow {
    id: number;
    name: React.ReactNode;
    status: React.ReactNode;
    created_date: React.ReactNode;
    product_name: string;
    cost_amount: string;
    last_update_status: string;
    identified_problem: string;
    necessary_procedure: string;
    circuits: string;
}

export function getUserWithVacationName(user: User): string {
    const vacation = user.current_or_next_vacation;

    if (!vacation) {
        return user.name;
    }

    const today = moment();
    const start = moment(vacation.start_at);
    const end = moment(vacation.end_at);

    if (start.isAfter(today, 'day')) {
        return `${user.name} (Férias previstas de ${start.format('DD/MM/YYYY')} até ${end.format('DD/MM/YYYY')})`;
    } else {
        return `${user.name} (Em férias até ${end.format('DD/MM/YYYY')})`;
    }
}

function getLastUsedTags() {
    let lastUsedTags = localStorage.getItem('lastUsedTags');
    if (lastUsedTags) {
        return JSON.parse(lastUsedTags) as ReactTagsData[];
    }
    return [];
}

function getLastUsedProjects() {
    let lastUsedProjects = localStorage.getItem('lastUsedProjects');
    if (lastUsedProjects) {
        return JSON.parse(lastUsedProjects) as OptionItem<number>[];
    }
    return [];
}

export function setLastUsedProjects(projectId: number, name: string) {
    let lastUsedProjects = getLastUsedProjects();
    let project = lastUsedProjects.find(p => p.value === projectId);
    if (project) {
        lastUsedProjects = lastUsedProjects.filter(p => p.value !== projectId);
    }
    lastUsedProjects.unshift({ value: projectId, label: name });
    if (lastUsedProjects.length > 3) {
        lastUsedProjects.pop();
    }
    localStorage.setItem('lastUsedProjects', JSON.stringify(lastUsedProjects));
}

export function setLastUsedTags(tag: ReactTagsData) {
    let lastUsedTags = getLastUsedTags();
    let tagIndex = lastUsedTags.findIndex(t => t.text === tag.text);
    if (tagIndex !== -1) {
        lastUsedTags.splice(tagIndex, 1);
    }
    lastUsedTags.unshift(tag);
    if (lastUsedTags.length > 5) {
        lastUsedTags.pop();
    }
    localStorage.setItem('lastUsedTags', JSON.stringify(lastUsedTags));
}

const apiFinalCustomer = new ServiceApi<FinalCustomer>('finalCustomer');
const apiIntegrator = new ServiceApi<Integrator>('integrator');
const apiProduct = new ServiceApi<Product>('product');
const apiTicketStatus = new ServiceApi<TicketStatus>('ticketStatus');
const apiTicketType = new ServiceApi<TicketType>('ticketType');
const apiUser = new ServiceApi<User>('user');
const api = new TaskApi();
const apiProject = new ServiceApi<Project>('project');
const apiTag = new ServiceApi<Tag>('tag', false);
const apiTicketCause = new ServiceApi<TicketCause>('ticketCause', false);
const apiTicketSolutionType = new ServiceApi<TicketSolutionType>('ticketSolutionType', false);
const apiChecklist = new ServiceApi<Checklist>('checklist', false);
const apiTaskChecklistItem = new ServiceApi<TaskChecklistItem>('taskChecklistItem', false);
const apiSoftwareVersion = new ServiceApi<Software>('softwareVersion');
const apiTechnicalAssistance = new ServiceApi<TechnicalAssistance>('technicalAssistance');
const apiFinalCustomerContract = new ServiceApi<FinalCustomerContract>('finalCustomerContract');

const KeyCodes = {
    comma: 188,
    enter: 13
};
export const delimiters = [KeyCodes.comma, KeyCodes.enter];

export interface AttachmentTaskRow extends AttachmentTask {
    edited?: boolean;
    commentIdx?: number;
}

export interface TaskChecklistRow extends TaskChecklist {
    checklistIdx?: number;
}

export interface ReactTagsData {
    id: string;
    text: string;
}

interface CloseConfirmationContext {
    submitType?: string | null;
    proceedCommentStatus?: boolean;
    proceedAddTag?: boolean;
    proceedStatusLimit?: boolean;
}

export enum FeedbackImproveItem {
    Hardware = 1,
    Documentation = 2,
    Software = 3
}

const feedbackImproveOptions = [
    { value: FeedbackImproveItem.Hardware, label: 'Hardware' },
    { value: FeedbackImproveItem.Documentation, label: 'Documentação' },
    { value: FeedbackImproveItem.Software, label: 'Software' }
];

export type TaskFormData = {
    name: string;
    description: string;
    solution: string;
    ticket_status_id: number | null;
    project_id: number | null;
    user_id: number | null;
    final_customer_id: number | null;
    ticket_type_id: number | null;
    ticket_cause_id: number | null;
    ticket_root_cause_id: number | null;
    ticket_origin_id: number | null;
    ticket_solution_type_id: number | null;
    products_s: number[];
    products_h: number[];
    customer_contacts: number[];
    observers: number[];
    attachments: AttachmentTaskRow[];
    comments: CommentTask[];
    priority: number | null;
    effort_estimation: string;
    delivery_forecast: Date | null;
    scheduled_date: Date | null;
    solution_time: string | null;
    required_dev_attach: boolean;
    tags: ReactTagsData[];
    checklists: TaskChecklistRow[];
    technical_assistances: Partial<TechnicalAssistance>[];
    prod_amount_to_be_produced: number | null;
    references: Task[];
    type_has_changed: boolean;
    feedback_to_improve_item: number | null;
    feedback_to_improve_text: string | null;
}

export interface TaskFormProps {
    title: React.ReactNode;
    item?: Task;
    onSubmit: (data: TaskFormData, attachmentsRemoved: AttachmentTaskRow[], isDirty?: boolean,
        sendEmail?: boolean, submitType?: string | null, oldUserId?: number | null, isInternal?: boolean, isStatusChanged?: boolean,
        oldTicketStatusId?: number | null, taskReminders?: Partial<TaskReminder>[], oldProjectId?: number | null, checklistsRemoved?: TaskChecklistRow[],
        newSoftwares?: FirmwareFormDialogData[], newFirmwaresLinks?: number[]) => Promise<any>;
    onCancel: () => any;
    onChange?: (changed: boolean) => any;
    onUndo?: () => any;
    finalCustomerId?: number;
    projectId?: number;
    commboxId?: number | null;
}

interface TechAssisTaskBoxProps {
    task?: Task;
    isDisabled: boolean;
    onSubmit: (data: TechnicalAssistanceDialogData) => any;
    technicalAssistances: Partial<TechnicalAssistance>[];
}

interface TechnicalAssistanceRow {
    id: number;
    name: React.ReactNode;
    status: React.ReactNode;
    product_name: string;
    invoice_number: string;
    integrator: string;
    code: string;
    seal: string;
}

function TechAssisTaskBox({ task, isDisabled, onSubmit, technicalAssistances }: TechAssisTaskBoxProps) {
    const [openTechnicalAssistanceDialog, setOpenTechnicalAssistanceDialog] = useState<boolean>(false);
    const { enqueueSnackbar } = useSnackbar();

    function getTechnicalAssistanceRow(row: Partial<TechnicalAssistance>, idx: number): TechnicalAssistanceRow {
        return {
            id: row.id || idx,
            name: <a href={`#/system/technicalAssistance/${row.id}/general`}>{row.name}</a>,
            status: row.ticket_status?.name ? <span style={{ display: 'flex', alignItems: 'center' }}><TicketStatusIcon icon={row.ticket_status.icon} style={{ marginRight: 5, color: row.ticket_status.color || '#000000' }} />{row.ticket_status.name}</span> : '',
            invoice_number: row.invoice_number || '',
            product_name: row.product?.name || '',
            integrator: row.integrator?.name || '',
            code: row.ticket_code || '',
            seal: row.seal || ''
        }
    }

    return <>
        <Box marginTop={3} marginBottom={0} display="flex">
            <Typography style={{ flex: 1 }} variant='subtitle2' className="subtitleGradientBackgorund">Assistências técnicas</Typography>
            <Tooltip placement="top" title={'Adicionar assistência'}>
                <IconButton
                    size='small'
                    color="inherit"
                    aria-label={'Adicionar assistência'}
                    onClick={() => setOpenTechnicalAssistanceDialog(true)}
                    disabled={isDisabled}
                >
                    <AddIcon />
                </IconButton>
            </Tooltip>
        </Box>
        <Divider style={{ marginBottom: 4 }} />
        {openTechnicalAssistanceDialog && <TechnicalAssistanceDialog
            open={openTechnicalAssistanceDialog}
            onCancel={() => setOpenTechnicalAssistanceDialog(false)}
            onSubmit={async (data) => {
                const seals = data.seals;
                if (data.seal) {
                    seals.push(data.seal);
                }
                // Check if the seal already exists in the technical assistances, if exists return it and show a message with the seals alredy in use
                const existingSeals = technicalAssistances.filter(ta => ta.seal && seals.includes(ta.seal));
                if (existingSeals.length > 0) {
                    enqueueSnackbar(`N° de Série já cadastrado em outra assistência técnica: ${existingSeals.map(ta => ta.seal).join(', ')}`, { variant: 'error' });
                    return;
                }

                onSubmit(data);
                setOpenTechnicalAssistanceDialog(false);
            }}
        />}
        <TableListPsim<TechnicalAssistanceRow>
            columns={[
                { field: 'id', width: 17, visible: false },
                { field: 'name', value: 'Assunto', alignContent: 'left' },
                { field: 'product_name', value: 'Produto', alignContent: 'left', width: 80 },
                { field: 'status', value: 'Status', alignContent: 'left', width: 195, verticalAlign: 'middle' },
                { field: 'integrator', value: 'Integrador / Cliente', alignContent: 'left' },
                { field: 'invoice_number', value: 'Nota fiscal', alignContent: 'center', width: 80 },
                { field: 'seal', value: 'N° Série', alignContent: 'center', width: 60 },
            ]}
            rows={technicalAssistances.map(getTechnicalAssistanceRow)}
            noPadding
            emptyRowsLabel={'Não há assistências técnicas'}
        />
    </>
}

interface TechnicalAssistanceDialogData {
    name: string;
    ticket_status_id: number | null;
    product_id: number | null;
    equipment_return: boolean;
    technical_assistance_id: number | null;
    without_invoice: boolean;
    invoice_number: string;
    observation_invoice: string;
    without_seal: boolean;
    seal: string;
    seal_old: string;
    user_id: number | null;
    charge_id: number | null;
    final_customer_id: number | null;
    ticket_type_id: number | null;
    integrator_id: number | null;
    ticket_cause_id: number | null;
    ticket_origin_id: number | null;
    software_version_id: number | null;
    identified_problem: string;
    necessary_procedure: string;
    firmware_updated: number;
    factory_reset: number;
    ip: string;
    tracking_post_office: string;
    post_office_date: Date | null;
    components: number[];
    damaged_circuit_blocks: number[];
    related_problems: number[];
    additional_item_received: string;
    cost_materials: number | null;
    cost_freight: number | null;
    cost_amount: number | null;
    description_customer_problem: string;
    resolution_observation: string;
    seals: string[];
    local_pickup: boolean;
    declaration_content: boolean;
    service_invoice: string | null;
    invoice_number_out: string | null;
    not_charged: boolean;
}

interface TechnicalAssistanceDialogProps {
    open: boolean
    onCancel: () => any;
    onSubmit: (data: TechnicalAssistanceDialogData) => any;
}

var timeoutBlurSeal = 0;

function TechnicalAssistanceDialog({ open, onCancel, onSubmit }: TechnicalAssistanceDialogProps) {
    const { enqueueSnackbar } = useSnackbar();
    const [isMultiAdd, setIsMultiAdd] = useState<boolean>(false);
    const [production, setProduction] = useState<Production | null>(null);
    const [disableFieldIp, setDisableFieldIp] = useState<boolean>(false);
    const [productKey, setProductKey] = useState<number>(0);
    const [technicalAssistanceSameSeal, setTechnicalAssistanceSameSeal] = useState<TechnicalAssistance[]>([]);

    useEffect(() => {
        return () => {
            window.clearTimeout(timeoutBlurSeal);
        }
    }, []);

    function getTechnicalAssistanceRow(row: TechnicalAssistance): LastTechnicalAssistanceRow {
        let nowYear = moment().format('YYYY');
        let rowYear = moment(row.created_at).format('YYYY');
        let created_at: React.ReactNode = moment(row.created_at).format('DD/MM HH') + 'h';
        if (nowYear !== rowYear) {
            created_at = <span style={{ color: '#DF7B00' }}>{moment(row.created_at).format('DD/MM/YYYY')}</span>;
        }

        return {
            id: row.id,
            name: <a className='visitedBlue' target="_blank" href={`#/system/technicalAssistance/${row.id}/general`}>{row.name}</a>,
            status: row.ticket_status?.name ? <span style={{ display: 'flex', alignItems: 'center' }}><TicketStatusIcon icon={row.ticket_status.icon} style={{ marginRight: 5 }} />{row.ticket_status.name}</span> : '',
            product_name: row.product?.name || '',
            created_date: created_at,
            cost_amount: row.cost_amount !== null ? formatCurrency(row.cost_amount) : '',
            last_update_status: row.last_update_status ? moment(row.last_update_status).format('DD/MM HH') + 'h' : '',
            identified_problem: row.identified_problem,
            necessary_procedure: row.necessary_procedure,
            circuits: row.damaged_circuit_blocks?.map(d => d.name).join(', ') || ''
        }
    }

    async function getTechnicalAssistanceSameSeal(seal?: string) {
        if (!seal) return [];
        const where: WhereCondition<TechnicalAssistance> = [];

        where.push(['seal', '=', seal]);
        where.push(['created_at', '>=', moment().subtract(6, 'months').toISOString()]);

        const result = await apiTechnicalAssistance.getList({
            where,
            order: { created_at: 'DESC' },
            relations: ['ticket_status', 'product', 'damaged_circuit_blocks']
        });

        return result;
    }

    return (
        <FormDialog<TechnicalAssistanceDialogData>
            show={open}
            title={'Adicionar assistência técnica'}
            dismiss={() => onCancel()}
            onSubmit={async (values, dirty, errors) => {
                window.clearTimeout(timeoutBlurSeal);
                if (errors) {
                    for (var error of Object.values(errors).filter(e => !!e)) {
                        enqueueSnackbar(error, { variant: 'error' });
                    }
                    return;
                }

                onSubmit(values);
            }}
            initialValues={{
                name: '',
                additional_item_received: 'Nenhum.',
                ticket_status_id: FixedIds.techAssisStatusAguardandoEnvio,
                product_id: null,
                equipment_return: false,
                technical_assistance_id: null,
                without_invoice: false,
                invoice_number: '',
                observation_invoice: '',
                without_seal: false,
                seal: '',
                seal_old: '',
                ip: '192.168.0.100',
                tracking_post_office: '',
                user_id: FixedIds.idUsuarioAtribuidoTechAssis,
                final_customer_id: null,
                ticket_type_id: null,
                integrator_id: null,
                ticket_origin_id: FixedIds.techAssisOriginSuporte,
                software_version_id: null,
                firmware_updated: 0,
                factory_reset: 0,
                charge_id: null,
                ticket_cause_id: null,
                identified_problem: '',
                necessary_procedure: '',
                post_office_date: null,
                components: [],
                damaged_circuit_blocks: [],
                related_problems: [],
                cost_amount: 0,
                cost_freight: null,
                cost_materials: null,
                description_customer_problem: '',
                resolution_observation: '',
                seals: [],
                local_pickup: false,
                declaration_content: false,
                service_invoice: '',
                invoice_number_out: '',
                not_charged: false
            }}
            validationSchema={{
                product_id: Yup.number()
                    .required()
                    .label('Produto'),
                // integrator_id: Yup.number()
                //     .required()
                //     .label('Integrador / Cliente')
            }}
            enableReinitialize={true}
            maxWidth='lg'
            fullWidth
        >
            {({ values, errors, setFieldValue, isSubmitting, handleChange, dirty }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <Grid container alignItems="center" spacing={1}>
                            {isMultiAdd ? <Grid alignContent={'center'} alignItems={'center'} display={'flex'} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <ListTextField
                                    value={values.seals || []}
                                    onChange={async (v) => {
                                        const uniqueSeals = Array.from(new Set(v.map(s => s.trim())));
                                        await setFieldValue('seals', uniqueSeals.slice(0, 50));
                                        if (v.length > 50) {
                                            enqueueSnackbar('Limite de 50 N° de Série', { variant: 'error' });
                                        }
                                    }}
                                    name="seals"
                                    label="Lista de N° de Série"
                                    rows={6}
                                    helperText='Um N° de Série por linha'
                                    required
                                />
                            </Grid>
                                : <Grid alignContent={'center'} alignItems={'center'} display={'flex'} item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TextField
                                        name="seal"
                                        label={'N° de Série'}
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        autoFocus
                                        required={(values.without_seal === false)}
                                        disabled={(values.without_seal === true)}
                                        inputProps={{ maxLength: 200 }}
                                        style={{ flex: 1 }}
                                        value={values.seal || ''}
                                        onChange={handleChange}
                                        onFocus={() => {
                                            if (values.seal !== values.seal_old) {
                                                setFieldValue('seal_old', values.seal);
                                            }
                                        }}
                                        onBlur={async () => {
                                            if (values.seal !== values.seal_old) {
                                                window.clearTimeout(timeoutBlurSeal);
                                                timeoutBlurSeal = window.setTimeout(async () => {
                                                    if (values.seal) {
                                                        await loadLastTechAssisBySeal(values.seal, setFieldValue, setProduction, setDisableFieldIp);
                                                        const techSameSealList = await getTechnicalAssistanceSameSeal(values.seal);
                                                        setTechnicalAssistanceSameSeal(techSameSealList);
                                                    } else {
                                                        setProduction(null);
                                                        setTechnicalAssistanceSameSeal([]);
                                                    }
                                                    setProductKey(prevKey => prevKey + 1);
                                                }, 500);
                                            }
                                        }}
                                        error={!!errors.seal && !!dirty.seal}
                                        helperText={!!errors.seal && !!dirty.seal && errors.seal}
                                    />
                                    <Tooltip placement="top" title={'Adicionar assistências em lote'}>
                                        <IconButton
                                            size='small'
                                            color="inherit"
                                            aria-label={'Adicionar assistências em lote'}
                                            onClick={async () => {
                                                await setFieldValue('without_seal', false);
                                                await setFieldValue('seal', '');
                                                await setFieldValue('seal_old', '');
                                                await setFieldValue('technical_assistance_id', null);
                                                await setFieldValue('equipment_return', false);
                                                setProduction(null);
                                                setDisableFieldIp(false);
                                                setIsMultiAdd(true);
                                            }}
                                        >
                                            <LibraryAddIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <FormControlLabel
                                        style={{ margin: 0 }}
                                        control={
                                            <Checkbox
                                                size="small"
                                                name='without_seal'
                                                onChange={async (_, v) => {
                                                    await setFieldValue('without_seal', v || false);
                                                    if (v === true) {
                                                        await setFieldValue('seal', '');
                                                    }
                                                }}
                                                checked={values.without_seal === true}
                                            />
                                        }
                                        label="Sem N° de Série"
                                    />
                                </Grid>}
                        </Grid>
                        {/* <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <SearchEntity<Integrator, 'id', 'name_with_cnpj_and_erp'>
                                    name="integrator_id"
                                    entity="integrator"
                                    valueField='id'
                                    labelField="name_with_cnpj_and_erp"
                                    label="Integrador / Cliente"
                                    value={values.integrator_id || null}
                                    onChangeHandle={async (_, v) => {
                                        await setFieldValue('integrator_id', v);
                                        await setFieldValue('final_customer_id', null);
                                    }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <SearchEntity<FinalCustomer, 'id', 'name'>
                                    name="final_customer_id"
                                    entity="finalCustomer"
                                    valueField='id'
                                    labelField="name"
                                    isClearable
                                    label="Cliente final"
                                    value={values.final_customer_id || null}
                                    onChangeHandle={async (_, v) => {
                                        await setFieldValue('final_customer_id', v);
                                    }}
                                    extraWhere={[['integrator_id', '=', values.integrator_id]]}
                                    isDisabled={!values.integrator_id}
                                    key={`final_customer_${values.integrator_id}`}
                                />
                            </Grid>
                        </Grid> */}
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <SelectSearch<boolean>
                                    name='equipment_return'
                                    label='Retorno de equipamento'
                                    options={[
                                        { label: 'Sim', value: true },
                                        { label: 'Não', value: false },
                                    ]}
                                    value={values.equipment_return}
                                    onChangeHandle={(_, v) => {
                                        setFieldValue('equipment_return', v || false)
                                    }}
                                    margin='dense'
                                    fullWidth
                                    required
                                    isDisabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <SearchEntity<Product, 'id', 'name'>
                                    name="product_id"
                                    entity="product"
                                    valueField='id'
                                    labelField="name"
                                    label="Produto"
                                    value={values.product_id || null}
                                    onChangeHandle={async (_, v) => {
                                        await setFieldValue('product_id', v);
                                        await setFieldValue('software_version_id', null);
                                    }}
                                    required
                                    extraWhere={[['use_in_technical_assistance', '=', true]]}
                                    key={`product_techassis_${productKey}`}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={1} container>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    name="description_customer_problem"
                                    label='Descrição do problema segundo cliente'
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    inputProps={{ maxLength: 200 }}
                                    value={values.description_customer_problem}
                                    onChange={handleChange}
                                    error={!!errors.description_customer_problem && !!dirty.description_customer_problem}
                                    helperText={!!errors.description_customer_problem && !!dirty.description_customer_problem && errors.description_customer_problem}
                                />
                            </Grid>
                        </Grid>
                        {isMultiAdd === false ? <>
                            <Box marginTop={3}>
                                <Typography variant='subtitle2' className="subtitleGradientBackgorund">Informações da Produção</Typography>
                            </Box>
                            <Divider style={{ marginBottom: 4 }} />
                            <Grid spacing={1} container>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3} style={{ display: 'flex', alignItems: 'center' }}>
                                    {production?.id ? <a target='_blank' className='visitedBlue' href={`#/system/production/${production.id}/general`}>Abrir Produção em nova guia</a> : null}
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_1"
                                        label='Criado por'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.user?.name || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_2"
                                        label='Data entrada'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.entry_at ? moment(production.entry_at).format('DD/MM/YYYY') : ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_3"
                                        label='Firmware'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.software_version?.name || ''}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_4"
                                        label='Revisão PCI'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.product_review_1?.name || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_5"
                                        label='Lote'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.product_batch_1?.name || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_6"
                                        label='Revisão Superior'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.product_review_2?.name || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_7"
                                        label='Lote Superior'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.product_batch_2?.name || ''}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        name="production_field_8"
                                        label='Observações'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        rows={3}
                                        multiline
                                        value={production?.observation || ''}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={1} container>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_9"
                                        label='MAC Address'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.mac_address || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_10"
                                        label='Data saída'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.left_at ? moment(production.left_at).format('DD/MM/YYYY') : ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_11"
                                        label='N° de pedido'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production?.order_number || ''}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                    <TextField
                                        name="production_field_12"
                                        label='Houve não conformidades?'
                                        margin="dense"
                                        variant="outlined"
                                        fullWidth
                                        value={production ? (production.non_conformities && production.non_conformities?.length > 0 ? 'Sim' : 'Não') : ''}
                                        disabled
                                        style={{
                                            ...(production && production.non_conformities && production.non_conformities?.length > 0 ? { backgroundColor: 'rgba(255,0,0,0.1)' } : {})
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Box marginTop={3}>
                                <Typography variant='subtitle2' className="subtitleGradientBackgorund">Assistências nos últimos 6 meses</Typography>
                            </Box>
                            <Divider style={{ marginBottom: 4 }} />
                            <TableListPsim<LastTechnicalAssistanceRow>
                                columns={[
                                    { field: 'id', width: 17, visible: false },
                                    { field: 'created_date', width: 70, value: 'Cadastro', alignContent: 'center' },
                                    { field: 'name', value: 'Assunto', alignContent: 'left' },
                                    { field: 'identified_problem', value: 'Prob. Ident.', alignContent: 'left' },
                                    { field: 'necessary_procedure', value: 'Proc. Necessário', alignContent: 'left' },
                                    { field: 'circuits', value: 'Blocos Avariados', alignContent: 'left' },
                                    { field: 'status', value: 'Status', alignContent: 'left', width: 195, verticalAlign: 'middle' },
                                    { field: 'last_update_status', value: 'Desde', alignContent: 'center', width: 70 },
                                    { field: 'cost_amount', value: 'Valor final', alignContent: 'right', width: 75 }
                                ]}
                                rows={technicalAssistanceSameSeal.map(getTechnicalAssistanceRow)}
                                noPadding
                                emptyRowsLabel={values.seal ? 'Nenhuma assistência cadastrada para esse número de série' : 'Nenhum número de série inserido'}
                            />
                        </> : null}
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting}
                            style={{ marginLeft: 10 }}>
                            Salvar
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

interface TaskAttachmentListProps {
    attachments: AttachmentTaskRow[];
    downloadAttachment: (name: string, systemAttachmentId?: number | null, systemAttachmentFile?: string) => void;
    moveAttachmentFromAnalysisToSolution?: (id: number, attachments: AttachmentTaskRow[], setFieldValue: any) => void;
    setFieldValue: any;
    openAttachmentDescriptionDialog: (idx: number) => void;
    removeAttachment: (idx: number, attachments: AttachmentTaskRow[], setFieldValue: any) => void;
    type: AttachmentTaskType;
    addAttachment: (attachments: AttachmentTaskRow[], type: AttachmentTaskType, setFieldValue: any, name: string, file?: File) => void;
    title: string;
    isDisabled?: boolean;
    enableMove?: boolean;
}

export function TaskAttachmentList(props: TaskAttachmentListProps) {
    const { attachments, downloadAttachment, setFieldValue, openAttachmentDescriptionDialog,
        removeAttachment, type, addAttachment, title, isDisabled, moveAttachmentFromAnalysisToSolution, enableMove } = props;
    let contadorAttachments = 0;

    var refInputFile = React.createRef<HTMLInputElement>();

    function inputChangeHandler(e: ChangeEvent<HTMLInputElement>) {
        const input = e.target;
        if (input?.files && input.files.length > 0) {
            Array.from(input.files).forEach(file => {
                addAttachment(attachments, type, setFieldValue, file.name, file);
            });
        }
    }

    function buttonClickHandler(e: MouseEvent<HTMLButtonElement>) {
        const input = refInputFile.current;
        input?.click();
    }

    return (<>
        <Box marginTop={3} marginBottom={0} display="flex" >
            <Typography style={{ flex: 1 }} variant='subtitle2' className="subtitleGradientBackgorund">{title}</Typography>
            {!isDisabled ? <Tooltip placement="top" title={'Adicionar anexo'}>
                <IconButton
                    size='small'
                    color="inherit"
                    aria-label={'Adicionar anexo'}
                    onClick={buttonClickHandler}
                >
                    <input
                        ref={refInputFile}
                        type='file'
                        style={{ display: 'none' }}
                        onChange={inputChangeHandler}
                        multiple={true}
                        accept={"*"}
                        id={`attachment-task-${type}`}
                    />
                    <AddIcon />
                </IconButton>
            </Tooltip> : null}
        </Box>
        <Divider style={{ marginBottom: 4 }} />
        {attachments.map((at, idx) => {
            return at.type === type ? <Box key={idx + '-' + type} marginBottom={1} display="flex">
                <div style={{ fontWeight: 'bold', display: 'flex', width: 35, alignItems: 'center' }} >#{`${++contadorAttachments}`}</div>
                <Box marginBottom={1} display="flex" flexDirection="column" flex={1} margin={0} overflow="hidden">
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
                        <AttachmentPreviewBox file={at.file} id={at.task_id || null} model="Task" name={at.name} systemAttachmentId={at.system_attachment_id} systemAttachmentFile={at.system_attachment?.file} />
                        <Typography style={{ flex: 1, alignItems: 'center', display: 'flex', overflow: 'hidden', paddingLeft: 5 }} title={at.name || at.system_attachment?.file} variant='body2'>{at.name || at.system_attachment?.file}</Typography>
                        {(at.system_attachment?.file_size || at.file_size) ? <Typography style={{ alignItems: 'center', display: 'flex', overflow: 'hidden', paddingRight: 5, paddingLeft: 5 }} variant='body2'>{convertFileByteToSizeString((at.system_attachment?.file_size || at.file_size)!)}</Typography> : null}
                        {at.id > 0 && !isDisabled && enableMove === true && type === AttachmentTaskType.Analysis && attachments.filter(c => c.type === AttachmentTaskType.Solution).length < 30 && moveAttachmentFromAnalysisToSolution ?
                            <Tooltip placement="top" title={'Mover anexo para solução'}>
                                <IconButton
                                    size='small'
                                    color="inherit"
                                    aria-label={'Mover anexo para solução'}
                                    onClick={() => moveAttachmentFromAnalysisToSolution(idx, attachments, setFieldValue)}
                                >
                                    <PublishedWithChangesIcon />
                                </IconButton>
                            </Tooltip> : null}
                        {at.name && at.id > 0 ? <>
                            <Tooltip placement="top" title={'Download do anexo'}>
                                <IconButton
                                    size='small'
                                    color="inherit"
                                    aria-label={'Download do anexo'}
                                    onClick={() => downloadAttachment(at.name, at.system_attachment_id, at.system_attachment?.file)}
                                >
                                    <DownloadIcon />
                                </IconButton>
                            </Tooltip>
                        </> : null}
                        {!isDisabled ? <>
                            <Tooltip placement="top" title={'Adicionar informação'}>
                                <IconButton
                                    size='small'
                                    color="inherit"
                                    aria-label={'Adicionar informação'}
                                    onClick={() => openAttachmentDescriptionDialog(idx)}
                                >
                                    <ChatIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip placement="top" title={'Remover anexo'}>
                                <IconButton
                                    size='small'
                                    color="inherit"
                                    aria-label={'Remover anexo'}
                                    onClick={() => removeAttachment(idx, attachments, setFieldValue)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </> : null}
                    </div>
                    {at.description ? <Typography style={{ flex: 1 }} variant='caption'>{at.description}</Typography> : null}
                </Box>
            </Box> : null;
        })}
    </>);
}

interface ProjectQuickCreateFormData {
    name: string;
    ticket_status_id: number | null;
    user_id: number | null;
    product_line_id: number | null;
    observers: number[];
    description: string;
    description_report: string;
}

interface ProjectQuickCreateFormDialogProps {
    open: boolean;
    onCancel: () => void;
    onSubmit: (data: ProjectQuickCreateFormData) => Promise<void>;
    observersOptions: MultiSelectOption<number>[];
    initialValues: ProjectQuickCreateFormData;
    loading: boolean;
}

function ProjectQuickCreateFormDialog({ open, onCancel, onSubmit, observersOptions, initialValues, loading }: ProjectQuickCreateFormDialogProps) {

    const { enqueueSnackbar } = useSnackbar();

    const validationSchema: FormValidationSchema<ProjectQuickCreateFormData> = {
        name: Yup.string().trim().required().min(3).max(80).label('Nome'),
        ticket_status_id: Yup.number().nullable().required().label('Status'),
        user_id: Yup.number().nullable().required().label('Responsável'),
        product_line_id: Yup.number().nullable().required().label('Linha de produto'),
        observers: Yup.array().of(Yup.number().nullable()).min(1).label('Observadores da tarefa'),
        description: Yup.string().trim().required().label('Descrição'),
        description_report: Yup.string().trim().required().label('Descrição para o relatório')
    };

    return (
        <FormDialog<ProjectQuickCreateFormData>
            show={open}
            title={'Cadastrar projeto'}
            dismiss={() => onCancel()}
            onSubmit={async (values, _dirty, errors) => {
                if (errors) {
                    const errorMessages = Object.values(errors).filter(Boolean) as React.ReactNode[];
                    if (errorMessages.length > 0) {
                        errorMessages.forEach(message => enqueueSnackbar(message, { variant: 'error' }));
                        return;
                    }
                }
                await onSubmit(values);
            }}
            initialValues={initialValues}
            enableReinitialize
            maxWidth='md'
            fullWidth
            validationSchema={validationSchema}
        >
            {({ values, errors, handleChange, setFieldValue, dirty, isSubmitting }) => (
                <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <TextField
                                name="name"
                                label='Nome'
                                margin="dense"
                                variant="outlined"
                                required
                                fullWidth
                                autoFocus={true}
                                value={values.name}
                                onChange={handleChange}
                                error={!!errors.name && !!dirty.name}
                                helperText={!!errors.name && !!dirty.name && errors.name}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <SearchEntity<TicketStatus, 'id', 'name'>
                                name="ticket_status_id"
                                entity="ticketStatus"
                                valueField='id'
                                labelField="name"
                                label="Status"
                                value={values.ticket_status_id}
                                onChangeHandle={(_, v) => setFieldValue('ticket_status_id', v)}
                                required
                                extraWhere={[['use_in_project', '=', true]]}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <SearchEntity<User, 'id', 'name'>
                                name="user_id"
                                entity="user"
                                valueField='id'
                                labelField="name"
                                label="Responsável"
                                value={values.user_id}
                                onChangeHandle={(_, v) => setFieldValue('user_id', v)}
                                required
                                extraWhere={[['type', '=', UserType.Commbox], ['active', '=', true]]}
                                relations={['current_or_next_vacation']}
                                customLabel={(user) => getUserWithVacationName(user)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                            <SearchEntity<ProductLine, 'id', 'name'>
                                name="product_line_id"
                                entity="productLine"
                                valueField='id'
                                labelField="name"
                                label="Linha de produto"
                                value={values.product_line_id}
                                onChangeHandle={(_, v) => setFieldValue('product_line_id', v)}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <MultiSelect<number>
                                name='observers'
                                label={'Observadores da tarefa'}
                                onChange={(selected) => setFieldValue('observers', selected)}
                                options={observersOptions}
                                values={values.observers}
                                required
                                helperText={errors.observers && errors.observers}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                name="description_report"
                                label={'Descrição para o relatório'}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                required
                                multiline
                                rows={3}
                                value={values.description_report}
                                onChange={handleChange}
                                error={!!errors.description_report && !!dirty.description_report}
                                helperText={!!errors.description_report && !!dirty.description_report && errors.description_report}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                name="description"
                                label={'Descrição'}
                                margin="dense"
                                variant="outlined"
                                fullWidth
                                required
                                multiline
                                rows={4}
                                value={values.description}
                                onChange={handleChange}
                                error={!!errors.description && !!dirty.description}
                                helperText={!!errors.description && !!dirty.description && errors.description}
                            />
                        </Grid>
                    </Grid>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting || loading}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting || loading}
                            style={{ marginLeft: 10 }}>
                            Salvar
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

interface BoxTaskChecklistItemProps {
    checkUncheckTaskChecklistItem: (checked: boolean, task_checklist_id: number, checklist_item_id: number, task_checklist_item_id?: number) => void;
    taskChecklists: TaskChecklistRow[];
    item: ChecklistItem;
    taskChecklist: TaskChecklistRow;
    isActualTicketStatusClosed: boolean;
}

function BoxTaskChecklistItem({ checkUncheckTaskChecklistItem, taskChecklists, item, taskChecklist, isActualTicketStatusClosed }: BoxTaskChecklistItemProps) {
    const [loading, setLoading] = useState<boolean>(false);

    async function onClickCheckbox() {
        setLoading(true);
        await checkUncheckTaskChecklistItem(!alredyChecked, taskChecklist.id, item.id, taskChecklistItem?.id);
        setLoading(false);
    }

    var taskChecklistTemp = taskChecklists.find(tc => tc.id === taskChecklist.id);
    var taskChecklistItem = taskChecklistTemp ? taskChecklistTemp.task_checklist_items?.find(tci => tci.checklist_item_id === item.id) : undefined;
    var created_at = taskChecklistItem?.created_at ? moment(taskChecklistItem.created_at).format('DD/MM/YYYY[, às] HH:mm') : '';

    var alredyChecked = !!taskChecklistItem;
    return <Box display={"flex"} position={"relative"}>
        {loading && <Box style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 10
        }}>
            <CircularProgress size={15} />
        </Box>}
        <Typography style={{ flex: 1, marginBottom: '3px', fontSize: '0.75rem', display: 'flex', alignItems: 'center' }} component={'div'} variant="body2">
            <FormControlLabel
                style={{ margin: 0 }}
                componentsProps={{ typography: { fontSize: '14px', marginRight: '5px' } }}
                control={
                    <Checkbox
                        name='is_item_checked'
                        onChange={async (_, v) => {
                            await onClickCheckbox();
                        }}
                        checked={alredyChecked}
                        size="small"
                        style={{ margin: 0, padding: '5px' }}
                        disabled={taskChecklist.id === 0 || taskChecklist.not_filled || (isActualTicketStatusClosed && (alredyChecked || !taskChecklist.is_mandatory))}
                    />
                }
                label={item.name}
            />
            {alredyChecked ? ` - ${taskChecklistItem?.user?.name} - ${created_at}` : null}
        </Typography>
    </Box>;
}

interface BoxTaskChecklistProps {
    idx: number;
    removeChecklist: (idx: number, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    checkUncheckTaskChecklistItem: (checked: boolean, task_checklist_id: number, checklist_item_id: number, task_checklist_item_id?: number) => void;
    setFieldValue: any;
    checklists: TaskChecklistRow[];
    taskChecklists: TaskChecklistRow[];
    taskChecklist: TaskChecklistRow;
    setTaskChecklistIsMandatory: (idx: number, taskChecklistId: number, is_mandatory: boolean, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    setTaskChecklistNotFilled: (taskChecklistId: number, not_filled: boolean, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    isActualTicketStatusClosed: boolean;
}

function BoxTaskChecklist({ idx, checkUncheckTaskChecklistItem, checklists, removeChecklist, setFieldValue, taskChecklists, taskChecklist, setTaskChecklistIsMandatory, isActualTicketStatusClosed, setTaskChecklistNotFilled }: BoxTaskChecklistProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const { user } = useAuthentication();

    async function setIsMandatory(idx: number, taskChecklistId: number, is_mandatory: boolean, checklists: TaskChecklistRow[], setFieldValue: any) {
        setLoading(true);
        await setTaskChecklistIsMandatory(idx, taskChecklistId, is_mandatory, checklists, setFieldValue);
        setLoading(false);
    }

    async function setNotFilled(taskChecklistId: number, not_filled: boolean, checklists: TaskChecklistRow[], setFieldValue: any) {
        setLoading(true);
        await setTaskChecklistNotFilled(taskChecklistId, not_filled, checklists, setFieldValue);
        setLoading(false);
    }

    var not_filled_at = taskChecklist?.not_filled_at ? moment(taskChecklist.not_filled_at).format('DD/MM/YYYY[, às] HH:mm') : '';

    return <Box key={`checklist-${idx}`} marginBottom={1} display="flex" flexDirection={"column"} position={'relative'}>
        {loading && <Box style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 11
        }}>
            <CircularProgress size={25} />
        </Box>}
        <Box display={"flex"}>
            <Typography flex={1} variant="subtitle1">{`#${idx + 1} -  ` + taskChecklist.checklist?.name}</Typography>
            {!taskChecklist.is_mandatory && taskChecklist.task_checklist_items?.length === 0 && taskChecklist.id !== 0 ?
                <>
                    <FormControlLabel
                        style={{ margin: 0 }}
                        componentsProps={{ typography: { fontSize: '14px', marginRight: '5px', color: taskChecklist.not_filled ? 'red' : undefined } }}
                        control={
                            <Checkbox
                                name='not_filled'
                                onChange={async (_, v) => {
                                    await setNotFilled(taskChecklist.id, !!v, checklists, setFieldValue);
                                }}
                                checked={taskChecklist.not_filled}
                                size="small"
                                style={{ margin: 0, padding: '5px' }}
                            />
                        }
                        label={'Não será necessário este checklist'}
                        disabled={isActualTicketStatusClosed}
                    />
                    {(taskChecklist.not_filled ? <Typography style={{ color: 'red', fontSize: '0.75em', display: 'flex', alignItems: 'center' }}>{` - ${taskChecklist.not_filled_user?.name} - ${not_filled_at}`}</Typography> : '')}
                </>
                : null}
            {user?.admin_type === UserAdminType.SuperAdmin && !taskChecklist.not_filled && !isActualTicketStatusClosed ? <>
                <FormControlLabel
                    style={{ margin: 0 }}
                    componentsProps={{ typography: { fontSize: '14px', marginRight: '5px' } }}
                    control={
                        <Checkbox
                            name='is_mandatory'
                            onChange={async (_, v) => {
                                await setIsMandatory(idx, taskChecklist.id, !!v, checklists, setFieldValue);
                            }}
                            checked={taskChecklist.is_mandatory}
                            size="small"
                            style={{ margin: 0, padding: '5px' }}
                        />
                    }
                    label={'Obrigatório'}
                />
                <Tooltip placement="top" title={'Remover checklist'}>
                    <IconButton
                        size='small'
                        color="inherit"
                        aria-label={'Remover checklist'}
                        onClick={() => removeChecklist(idx, checklists, setFieldValue)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </> : (taskChecklist.is_mandatory ? <Typography style={{ color: 'red', fontSize: '0.75rem' }}>Obrigatório</Typography> : null)}
        </Box>
        <Box marginBottom={1} display="flex" flexDirection="column" flex={1} margin={0} overflow="hidden">
            {taskChecklist.checklist?.checklist_items && taskChecklist.checklist?.checklist_items.map((item, idx2) => {
                return <BoxTaskChecklistItem
                    key={`checklist-${idx}-item-${idx2}`}
                    checkUncheckTaskChecklistItem={checkUncheckTaskChecklistItem}
                    item={item}
                    taskChecklist={taskChecklist}
                    taskChecklists={taskChecklists}
                    isActualTicketStatusClosed={isActualTicketStatusClosed}
                />
            })}
        </Box>
    </Box>;
}

interface TaskChecklistListProps {
    checklists: TaskChecklistRow[];
    taskChecklists: TaskChecklistRow[];
    setFieldValue: any;
    openAddChecklistDialog: () => void;
    removeChecklist: (idx: number, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    checkUncheckTaskChecklistItem: (checked: boolean, task_checklist_id: number, checklist_item_id: number, task_checklist_item_id?: number) => void;
    setTaskChecklistIsMandatory: (idx: number, taskChecklistId: number, is_mandatory: boolean, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    setTaskChecklistNotFilled: (taskChecklistId: number, not_filled: boolean, checklists: TaskChecklistRow[], setFieldValue: any) => void;
    isActualTicketStatusClosed: boolean;
}

export function TaskChecklistList(props: TaskChecklistListProps) {
    const { checklists, openAddChecklistDialog, removeChecklist, setFieldValue, checkUncheckTaskChecklistItem, taskChecklists, setTaskChecklistIsMandatory, isActualTicketStatusClosed, setTaskChecklistNotFilled } = props;
    const { user } = useAuthentication();

    return (<>
        <Box marginTop={3} marginBottom={0} display="flex">
            <Typography style={{ flex: 1 }} variant='subtitle2' className="subtitleGradientBackgorund">Checklists</Typography>
            {user?.admin_type === UserAdminType.SuperAdmin && !isActualTicketStatusClosed ? <Tooltip placement="top" title={'Adicionar checklist'}>
                <IconButton
                    size='small'
                    color="inherit"
                    aria-label={'Adicionar checklist'}
                    onClick={() => openAddChecklistDialog()}
                >
                    <AddIcon />
                </IconButton>
            </Tooltip> : null}
        </Box>
        <Divider style={{ marginBottom: 4 }} />
        {checklists.map((taskChecklist, idx) => {
            return <BoxTaskChecklist
                key={`checklist-${idx}`}
                idx={idx}
                checkUncheckTaskChecklistItem={checkUncheckTaskChecklistItem}
                checklists={checklists}
                removeChecklist={removeChecklist}
                setFieldValue={setFieldValue}
                taskChecklist={taskChecklists.find(tc => tc.id === taskChecklist.id) || taskChecklist}
                taskChecklists={taskChecklists}
                setTaskChecklistIsMandatory={setTaskChecklistIsMandatory}
                isActualTicketStatusClosed={isActualTicketStatusClosed}
                setTaskChecklistNotFilled={setTaskChecklistNotFilled}
            />;
        })}
    </>);
}

interface TaskReferenceListProps {
    references: Task[];
    openAddTaskReferenceDialog: () => void;
    removeReference: (id: number, references: Task[], setFieldValue: any) => void;
    setFieldValue: any;
    referenced_by: Task[];
}

export function TaskReferenceList(props: TaskReferenceListProps) {
    const { references, openAddTaskReferenceDialog, removeReference, setFieldValue, referenced_by } = props;
    const { user } = useAuthentication();
    const permissionByDepartment = getUserDepartmentPermissions(user);
    function getRow(reference: Task) {
        let taskLink = reference.project_id && !!permissionByDepartment.perm_menu_projects ? `#/system/task/project/${reference.project_id}/task/${reference.id}/general` : `#/system/task/${reference.id}/general`;
        let userName: React.ReactNode = '';
        if (user?.id === reference.user?.id) {
            userName = <b>Eu</b>;
        } else {
            let userNameList = reference.user?.name.split(' ');
            userName = userNameList ? userNameList.filter((n, i, a) => i === 0 || i + 1 === a.length).map((n, i) => {
                if (i === 0) {
                    return n;
                } else {
                    return n.slice(0, 1) + '.';
                }
            }).join(' ') : '';
        }
        return {
            id: reference.id,
            name: <a href={taskLink} target='_blank'>{reference.name}</a>,
            ticket_code: reference.ticket_code,
            status: reference.ticket_status?.name || '',
            assigned_to: userName,
            remove: !referenced_by.includes(reference) && <Tooltip placement="top" title={'Remover referência'}>
                <IconButton
                    size='small'
                    color="inherit"
                    aria-label={'Remover referência'}
                    onClick={() => removeReference(reference.id, references, setFieldValue)}
                >
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
        };
    }

    const mergedReferences = [...references, ...referenced_by];
    const list: Task[] = mergedReferences.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });

    return (<>
        <Box marginTop={3} marginBottom={0} display="flex">
            <Typography style={{ flex: 1 }} variant='subtitle2' className="subtitleGradientBackgorund">Chamados relacionados</Typography>
            <Tooltip placement="top" title={'Adicionar referência'}>
                <IconButton
                    size='small'
                    color="inherit"
                    aria-label={'Adicionar referência'}
                    onClick={() => openAddTaskReferenceDialog()}
                >
                    <AddIcon />
                </IconButton>
            </Tooltip>
        </Box>
        <Divider style={{ marginBottom: 4 }} />
        <TableListPsim<{
            id: number;
            name: React.ReactNode;
            ticket_code: React.ReactNode;
            status: React.ReactNode;
            remove: React.ReactNode;
            assigned_to: React.ReactNode;
        }>
            columns={[
                { field: 'id', width: 17, visible: false },
                { field: 'ticket_code', width: 80, value: 'Código', alignContent: 'center' },
                { field: 'name', value: 'Assunto', alignContent: 'left' },
                { field: 'status', value: 'Status', alignContent: 'left', width: 300, verticalAlign: 'middle' },
                { field: 'assigned_to', value: 'Usuário', alignContent: 'left', width: 80 },
                { field: 'remove', value: 'Remover', alignContent: 'center', width: 100, verticalAlign: 'middle' },
            ]}
            rows={list.map(getRow)}
            noPadding
            emptyRowsLabel={'Nenhum chamado relacionado'}
        />
    </>);
}

interface ChecklistFormDialogProps {
    addChecklistDialogOpen: boolean
    checklists: TaskChecklistRow[];
    onCancel: () => any;
    onSubmit: (checklists: TaskChecklistRow[], setFieldValue: any, checklist_id: number, is_mandatory: boolean) => any;
    setFieldValue: any;
}

function ChecklistFormDialog({ addChecklistDialogOpen, checklists, onCancel, onSubmit, setFieldValue }: ChecklistFormDialogProps) {
    const extraWhere: WhereCondition<Checklist> = checklists.length > 0 ? [['id', 'notIn', checklists.map(c => c.checklist_id)]] : undefined;

    return (
        <FormDialog<{ checklist_id: number | null; is_mandatory: boolean; }>
            show={addChecklistDialogOpen}
            title={'Adicionar checklist'}
            dismiss={() => onCancel()}
            onSubmit={(values, errors) => {
                const { checklist_id, is_mandatory } = values;
                if (checklist_id)
                    onSubmit(checklists, setFieldValue, checklist_id, is_mandatory);
            }}
            initialValues={{ checklist_id: null, is_mandatory: false }}
            enableReinitialize={true}
            maxWidth='sm'
            fullWidth
        >
            {({ values, errors, setFieldValue, isSubmitting }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <SearchEntity<Checklist, 'id', 'name'>
                            name="checklist_id"
                            entity="checklist"
                            valueField='id'
                            labelField="name"
                            label="Checklist"
                            value={values.checklist_id || null}
                            onChangeHandle={(_, v) => setFieldValue('checklist_id', v)}
                            required
                            extraWhere={extraWhere}
                        />
                        <SelectSearch<boolean>
                            name='is_mandatory'
                            label='É de preenchimento obrigatório?'
                            options={[
                                { label: 'Não', value: false },
                                { label: 'Sim', value: true }
                            ]}
                            value={values.is_mandatory}
                            onChangeHandle={(_, v) => {
                                setFieldValue('is_mandatory', !!v);
                            }}
                            margin='dense'
                            fullWidth
                            required
                        />
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting}
                            style={{ marginLeft: 10 }}>
                            OK
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

interface TaskReferenceFormDialogProps {
    addReferenceDialogOpen: boolean
    references: Task[];
    onCancel: () => any;
    onSubmit: (references: Task[], setFieldValue: any, ref_task_id: number) => any;
    setFieldValue: any;
    task_id?: number;
    referenced_by: Task[];
}

function TaskReferenceFormDialog({ addReferenceDialogOpen, references, onCancel, onSubmit, setFieldValue, task_id, referenced_by }: TaskReferenceFormDialogProps) {
    const notIn = references.map(c => c.id);
    if (task_id) {
        notIn.push(task_id);
    }
    if (referenced_by && referenced_by.length > 0) {
        notIn.push(...referenced_by.map(c => c.id));
    }
    const extraWhere: WhereCondition<Task> = notIn.length > 0 ? [['id', 'notIn', notIn]] : undefined;

    return (
        <FormDialog<{ ref_task_id: number | null; }>
            show={addReferenceDialogOpen}
            title={'Vincular chamado relacionado'}
            dismiss={() => onCancel()}
            onSubmit={(values, errors) => {
                const { ref_task_id } = values;
                if (ref_task_id)
                    onSubmit(references, setFieldValue, ref_task_id);
            }}
            initialValues={{ ref_task_id: null }}
            enableReinitialize={true}
            maxWidth='sm'
            fullWidth
        >
            {({ values, errors, setFieldValue, isSubmitting }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <SearchEntity<Task, 'id', 'name'>
                            name="task_id"
                            entity="task"
                            valueField='id'
                            labelField="name"
                            label="Tarefa"
                            value={values.ref_task_id || null}
                            onChangeHandle={(_, v) => setFieldValue('ref_task_id', v)}
                            required
                            extraWhere={extraWhere}
                            likeColumns={['name', 'ticket_code', 'user.name']}
                            relations={['user']}
                            customLabel={(task: Task) => {
                                return `${task.ticket_code} - ${task.name}`;
                            }}
                            isClearable
                        />
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting}
                            style={{ marginLeft: 10 }}>
                            OK
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

export interface TaskAttachmentDescriptionFormDialogProps {
    attachmentDescriptionDialogOpen: boolean;
    onSubmit: (description: string) => any;
    onCancel: () => any;
    attachments: AttachmentTaskRow[];
    attachmentsEditingIdx: number | null;
}

interface TaskAttachmentDescriptionFormDialogData {
    description: string;
}

export function TaskAttachmentDescriptionFormDialog(props: TaskAttachmentDescriptionFormDialogProps) {

    const { attachmentDescriptionDialogOpen, onCancel, attachments, attachmentsEditingIdx, onSubmit } = props;

    function onSubmitHandler(data: TaskAttachmentDescriptionFormDialogData) {
        onSubmit(data.description);
    }

    function getDescription(): string {
        if (attachmentsEditingIdx === null) return '';

        return attachments[attachmentsEditingIdx].description;
    }

    return (
        <FormDialog<TaskAttachmentDescriptionFormDialogData>
            show={attachmentDescriptionDialogOpen}
            title={'Descrição do anexo'}
            dismiss={() => null}
            onSubmit={(values, errors) => {
                const { description } = values;
                onSubmitHandler({ description });
            }}
            initialValues={{ description: getDescription() }}
            enableReinitialize={true}
            maxWidth='sm'
            fullWidth
        >
            {({ values, errors, handleChange, setFieldValue, isSubmitting, dirty }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <TextField
                            name="description"
                            label={"Descrição"}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            value={values.description}
                            onChange={handleChange}
                            error={!!errors.description && !!dirty.description}
                            helperText={!!errors.description && !!dirty.description && errors.description}
                        />
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton><DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting}
                            style={{ marginLeft: 10 }}
                        >
                            OK
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

export interface FirmwareFormDialogData {
    name: string;
    type: SoftwareVersionType;
    version: string;
    version_status: SoftwareVersionStatus;
    new_features: string;
    corrections_made: string;
    known_bugs: string;
    data: File | null;
    data_2: File | null;
    data_3: File | null;
    data_4: File | null;
    data_5: File | null;
    firmware_date: Date | null;
    homologated_at: Date | null;
    general_observations: string;
}

interface FirmwareFormDialogProps {
    firmwareDialogOpen: boolean
    onCancel: () => any;
    onSubmit: (data: FirmwareFormDialogData, software: Software | null) => any;
    firmwares: FirmwareFormDialogData[];
}

function FirmwareFormDialog({ firmwareDialogOpen, onCancel, onSubmit, firmwares }: FirmwareFormDialogProps) {
    const { enqueueSnackbar } = useSnackbar();

    async function setFilesData(setFieldValue: any, f: File, type: number, name: string, version: string) {
        let fileExt = 'bin';
        let fieldName = 'data';
        if (type === 2) {
            fileExt = 's19';
            fieldName = 'data_2';
        } else if (type === 3) {
            fileExt = 'mot';
            fieldName = 'data_3';
        } else if (type === 4) {
            fileExt = 'sap';
            fieldName = 'data_4';
        } else if (type === 5) {
            fileExt = 'srec';
            fieldName = 'data_5';
        }

        let file = f;
        let fileName = file.name.split('.');

        if (fileName[fileName.length - 1].toLocaleLowerCase() !== fileExt) {
            enqueueSnackbar(`Apenas arquivos do tipo ${fileExt} são aceitos.`, { variant: 'error' });
            return;
        }

        if (name === '') {
            await setFieldValue('name', file.name.split('.' + fileExt)[0]);
        }

        if (version === '') {
            let version = file.name.split('.' + fileExt)[0].split('_');
            if (version.length === 2) {
                await setFieldValue('version', version[1]);
            }
        }

        await setFieldValue(fieldName, file);
    }

    return (
        <FormDialog<FirmwareFormDialogData>
            show={firmwareDialogOpen}
            title={'Adicionar firmware'}
            dismiss={() => onCancel()}
            onSubmit={async (values, dirty, errors) => {
                if (!values.data && !values.data_2 && !values.data_3 && !values.data_4) {
                    enqueueSnackbar('É necessário anexar ao menos um arquivo.', { variant: 'error' });
                    return;
                }
                if (errors) {
                    for (var error of Object.values(errors).filter(e => !!e)) {
                        enqueueSnackbar(error, { variant: 'error' });
                    }
                    return;
                }

                const where: WhereCondition<Software> = [
                    ['name', '=', values.name]
                ];
                const list = await apiSoftwareVersion.getList({ where });
                let software = list.length > 0 ? list[0] : null;

                onSubmit(values, software);
            }}
            initialValues={{
                name: '',
                type: SoftwareVersionType.Firmware,
                version: '',
                version_status: SoftwareVersionStatus.Homologation,
                new_features: '',
                corrections_made: '',
                known_bugs: '',
                data: null,
                data_2: null,
                data_3: null,
                data_4: null,
                data_5: null,
                firmware_date: null,
                homologated_at: null,
                general_observations: ''
            }}
            validationSchema={{
                name: Yup.string()
                    .trim()
                    .required()
                    .min(3)
                    .max(100)
                    .label('Nome'),
                version: Yup.string()
                    .trim()
                    .required()
                    .min(1)
                    .max(100)
                    .label('Versão')
            }}
            enableReinitialize={true}
            maxWidth='md'
            fullWidth
        >
            {({ values, errors, setFieldValue, isSubmitting, handleChange, dirty }) => (
                <>
                    <FormControl fullWidth variant="outlined" margin='dense'>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    name="name"
                                    label='Nome'
                                    margin="dense"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    value={values.name}
                                    onChange={handleChange}
                                    error={!!errors.name && !!dirty.name}
                                    helperText={!!errors.name && !!dirty.name && errors.name}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                <TextField
                                    name="version"
                                    label='Versão'
                                    margin="dense"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    value={values.version}
                                    onChange={handleChange}
                                    error={!!errors.version && !!dirty.version}
                                    helperText={!!errors.version && !!dirty.version && errors.version}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    name="new_features"
                                    label={"Novas funcionalidades"}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={values.new_features}
                                    onChange={handleChange}
                                    error={!!errors.new_features && !!dirty.new_features}
                                    helperText={!!errors.new_features && !!dirty.new_features && errors.new_features}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    name="corrections_made"
                                    label={"Correções realizadas"}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={values.corrections_made}
                                    onChange={handleChange}
                                    error={!!errors.corrections_made && !!dirty.corrections_made}
                                    helperText={!!errors.corrections_made && !!dirty.corrections_made && errors.corrections_made}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    name="general_observations"
                                    label={"Observações gerais"}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={values.general_observations}
                                    onChange={handleChange}
                                    error={!!errors.general_observations && !!dirty.general_observations}
                                    helperText={!!errors.general_observations && !!dirty.general_observations && errors.general_observations}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Box marginBottom={2} marginTop={2} display="flex">
                                    <FileInputButton accept=".bin" color="primary" variant="contained" size='small' onFileChange={async (f) => await setFilesData(setFieldValue, f, 1, values.name, values.version)}>
                                        Selecione arquivo binário (.bin)
                                    </FileInputButton>
                                    <Box marginLeft={2} display="flex" alignItems="center">
                                        {values.data && values.data.name}
                                    </Box>
                                </Box>
                                <Box marginBottom={2} marginTop={2} display="flex">
                                    <FileInputButton accept=".s19" color="primary" variant="contained" size='small' onFileChange={async (f) => await setFilesData(setFieldValue, f, 2, values.name, values.version)}>
                                        Selecione arquivo (.s19)
                                    </FileInputButton>
                                    <Box marginLeft={2} display="flex" alignItems="center">
                                        {values.data_2 && values.data_2.name}
                                    </Box>
                                </Box>
                                <Box marginBottom={2} marginTop={2} display="flex">
                                    <FileInputButton accept=".mot" color="primary" variant="contained" size='small' onFileChange={async (f) => await setFilesData(setFieldValue, f, 3, values.name, values.version)}>
                                        Selecione arquivo (.mot)
                                    </FileInputButton>
                                    <Box marginLeft={2} display="flex" alignItems="center">
                                        {values.data_3 && values.data_3.name}
                                    </Box>
                                </Box>
                                <Box marginBottom={2} marginTop={2} display="flex">
                                    <FileInputButton accept=".sap" color="primary" variant="contained" size='small' onFileChange={async (f) => await setFilesData(setFieldValue, f, 4, values.name, values.version)}>
                                        Selecione arquivo (.sap)
                                    </FileInputButton>
                                    <Box marginLeft={2} display="flex" alignItems="center">
                                        {values.data_4 && values.data_4.name}
                                    </Box>
                                </Box>
                                <Box marginBottom={2} marginTop={2} display="flex">
                                    <FileInputButton accept=".srec" color="primary" variant="contained" size='small' onFileChange={async (f) => await setFilesData(setFieldValue, f, 5, values.name, values.version)}>
                                        Selecione arquivo (.srec)
                                    </FileInputButton>
                                    <Box marginLeft={2} display="flex" alignItems="center">
                                        {values.data_5 && values.data_5.name}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            Cancelar
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            disabled={isSubmitting}
                            style={{ marginLeft: 10 }}>
                            Salvar
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );
}

interface TaskCloseConfirmationResult {
    ticket_type_id: number | null;
    project_id: number | null;
    feedback_to_improve_item: number | null;
    feedback_to_improve_text: string | null;
}

interface TaskCloseConfirmationDialogProps {
    open: boolean;
    isInternal: boolean;
    values: TaskFormData;
    onCancel: () => void;
    onConfirm: (data: TaskCloseConfirmationResult) => void;
    iaSuggestions: string[];
    iaSuggestionsLoading: boolean;
    onRequestIaSuggestions: () => void;
}

function TaskCloseConfirmationDialog({
    open,
    isInternal,
    values,
    onCancel,
    onConfirm,
    iaSuggestions,
    iaSuggestionsLoading,
    onRequestIaSuggestions
}: TaskCloseConfirmationDialogProps) {
    const [localTicketTypeId, setLocalTicketTypeId] = useState<number | null>(null);
    const [localProjectId, setLocalProjectId] = useState<number | null>(null);
    const [localFeedbackItem, setLocalFeedbackItem] = useState<number | null>(null);
    const [localFeedbackText, setLocalFeedbackText] = useState<string>('');

    useEffect(() => {
        if (open) {
            setLocalTicketTypeId(values.ticket_type_id || null);
            setLocalProjectId(values.project_id || null);
            setLocalFeedbackItem(values.feedback_to_improve_item || null);
            setLocalFeedbackText(values.feedback_to_improve_text || '');
        }
    }, [open, values.project_id, values.ticket_type_id, values.feedback_to_improve_item, values.feedback_to_improve_text]);

    const feedbackSelectionValue = localFeedbackItem ? String(localFeedbackItem) : '';

    return (
        <Dialog
            open={open}
            onClose={(e, r) => {
                if (r !== 'backdropClick')
                    onCancel();
            }}
            maxWidth="md"
            fullWidth
            disableEscapeKeyDown
        >
            <DialogTitle>Confirme o encerramento do chamado</DialogTitle>
            <DialogContent dividers>
                <Typography variant='body2'>Antes de encerrar, confirme o tipo do chamado, o projeto associado e se existe algum ponto a melhorar.</Typography>
                <Grid container spacing={2} marginTop={1}>
                    <Grid item xs={12} md={6}>
                        <SearchEntity<TicketType, 'id', 'name'>
                            name="ticket_type_id"
                            entity="ticketType"
                            valueField='id'
                            labelField="name"
                            label="Tipo do chamado"
                            value={localTicketTypeId}
                            onChangeHandle={(_, v) => setLocalTicketTypeId(v)}
                            extraWhere={[[(!isInternal ? 'use_in_task' : 'use_in_task_internal'), '=', true]]}
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SearchEntity<Project, 'id', 'name'>
                            name="project_id"
                            entity="project"
                            valueField='id'
                            labelField="name"
                            label="Projeto"
                            value={localProjectId}
                            required
                            onChangeHandle={(_, v) => setLocalProjectId(v)}
                            extraWhere={[['ticket_status.closed', '=', false], ['use_in_task' + (isInternal ? '_internal' : ''), '=', true]]}
                            useOldWhereApi
                        />
                    </Grid>
                </Grid>
                <Box marginTop={3}>
                    <Typography variant='subtitle2'>Algo precisa ser melhorado?</Typography>
                    <RadioGroup
                        row
                        name="feedback_to_improve_item"
                        value={feedbackSelectionValue}
                        onChange={(event) => {
                            const value = event.target.value ? parseInt(event.target.value) : null;
                            if (!value) {
                                setLocalFeedbackText('');
                            }
                            setLocalFeedbackItem(value);
                        }}
                    >
                        <FormControlLabel value="" control={<Radio size='small' />} label="Não" />
                        {feedbackImproveOptions.map((option) => (
                            <FormControlLabel key={option.value} value={String(option.value)} control={<Radio size='small' />} label={option.label} />
                        ))}
                    </RadioGroup>
                </Box>
                <Box marginTop={2}>
                    <TextField
                        name="feedback_to_improve_text"
                        label={'Descreva a melhoria'}
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        value={localFeedbackText}
                        disabled={!localFeedbackItem}
                        required={!!localFeedbackItem}
                        onChange={(event) => setLocalFeedbackText(event.target.value)}
                    />
                </Box>
                {feedbackSelectionValue ? <>
                    <Box marginTop={3}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap="wrap"
                            marginBottom={iaSuggestions.length > 0 ? 1.5 : 1}
                            gap={1}
                        >
                            <Box display="flex" alignItems="center">
                                <SmartToyIcon style={{ marginRight: 8 }} />
                                <Typography variant='subtitle2'>Sugestões do LanzaBot</Typography>
                            </Box>
                            <DefaultButton
                                size='small'
                                variant="outlined"
                                type='button'
                                onClick={onRequestIaSuggestions}
                                disabled={iaSuggestionsLoading}
                                startIcon={<SmartToyIcon fontSize="small" />}
                            >
                                {iaSuggestionsLoading ? 'Buscando...' : iaSuggestions.length > 0 ? 'Recarregar sugestões' : 'Buscar sugestões'}
                            </DefaultButton>
                        </Box>
                        {iaSuggestionsLoading && (
                            <Box marginBottom={iaSuggestions.length > 0 ? 1 : 0} display="flex" alignItems="center" gap={1}>
                                <CircularProgress size={16} />
                                <Typography variant='body2' color="text.secondary">
                                    Buscando sugestões, aguarde...
                                </Typography>
                            </Box>
                        )}
                        {iaSuggestions.length > 0 ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1.5,
                                    maxHeight: 300,
                                    overflow: 'auto',
                                    padding: 0.5
                                }}
                            >
                                {iaSuggestions.map((suggestion, index) => (
                                    <Box
                                        key={`ia-suggestion-${index}`}
                                        sx={{
                                            padding: 2,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            borderRadius: 2,
                                            backgroundColor: 'background.paper',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                boxShadow: 1,
                                                backgroundColor: 'action.hover'
                                            }
                                        }}
                                    >
                                        <Box display="flex" alignItems="flex-start" gap={1}>
                                            <Chip
                                                label={`#${index + 1}`}
                                                size="small"
                                                color="primary"
                                                variant="outlined"
                                                sx={{ minWidth: 40 }}
                                            />
                                            <Box flex={1}>
                                                <Typography variant='body2' style={{ whiteSpace: 'pre-wrap' }}>
                                                    {suggestion}
                                                </Typography>
                                                <Box marginTop={1.5} display="flex" justifyContent="flex-end">
                                                    <DefaultButton
                                                        size='small'
                                                        variant="outlined"
                                                        type='button'
                                                        onClick={() => setLocalFeedbackText((old) => old ? old + '\n' + suggestion : suggestion)}
                                                        startIcon={<PublishedWithChangesIcon fontSize="small" />}
                                                    >
                                                        Usar esta sugestão
                                                    </DefaultButton>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        ) : (
                            !iaSuggestionsLoading && (
                                <Typography variant='body2' color="text.secondary">
                                    Nenhuma sugestão carregada. Clique em "Buscar sugestões" para consultar o LanzaBot.
                                </Typography>
                            )
                        )}
                    </Box>
                </> : null}
            </DialogContent>
            <DialogActions>
                <ErrorButton onClick={onCancel} variant="contained" size='small' type='button'>Cancelar</ErrorButton>
                <DefaultButton
                    onClick={() => onConfirm({
                        ticket_type_id: localTicketTypeId,
                        project_id: localProjectId,
                        feedback_to_improve_item: localFeedbackItem,
                        feedback_to_improve_text: localFeedbackText || null
                    })}
                    variant="contained"
                    size='small'
                    type='button'
                >
                    Confirmar encerramento
                </DefaultButton>
            </DialogActions>
        </Dialog>
    );
}

interface RulesByTicketType {
    ticket_status_ids: number[];
    rule_tag: TicketLayoutTypeRule;
    rule_final_customer: TicketLayoutTypeRule;
    rule_require_attachment_development: TicketLayoutTypeRule;
    rule_origin: TicketLayoutTypeRule;
    rule_client_contacts: TicketLayoutTypeRule;
    rule_post_service_tab: TicketLayoutTypeRule;
    rule_effort_estimate: TicketLayoutTypeRule;
    rule_delivery_forecast: TicketLayoutTypeRule;
    rule_quantity_to_be_produced: TicketLayoutTypeRule;
    rule_last_status_update: TicketLayoutTypeRule;
    rule_attachment_client: TicketLayoutTypeRule;
    rule_attachment_analysis: TicketLayoutTypeRule;
    rule_attachment_solution: TicketLayoutTypeRule;
    rule_checklist: TicketLayoutTypeRule;
    rule_comment_attachment: TicketLayoutTypeRule;
    rule_comment_reminder: TicketLayoutTypeRule;
    loaded: boolean;
    ticket_type_id: number | null;
}

const eventEmmiter = new EventEmitter<TicketHistoryEventEmitterType>();

export default function TaskForm(props: TaskFormProps) {
    const { title, item, onSubmit, onCancel, onChange, onUndo, finalCustomerId, projectId, commboxId } = props;

    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuthentication();
    const theme = useTheme();
    const setLoading = useLoading();
    const isInternal = !!(finalCustomerId || commboxId === item?.final_customer_id);
    const alertDialog = useAlert();

    const userDepartmentIds = getUserDepartmentsIds(user);
    const allow_edit_task_gen_att_cli = item?.ticket_type_id !== FixedIds.ticketTypeFalhaHardware && (!!user?.allow_edit_task_gen_att_cli || !!finalCustomerId || item?.final_customer?.name === 'Commbox');
    const allow_edit_task_resolution = item?.ticket_type_id !== FixedIds.ticketTypeFalhaHardware && (!!user?.allow_edit_task_resolution || user?.id === item?.created_by_user_id);
    const allow_send_task_client_email = !!user?.allow_send_task_client_email;
    const disable_task_auto_assign = !!user?.disable_task_auto_assign;
    const int_task_def_ticket_type_id = user?.int_task_def_ticket_type_id || null;
    const int_task_def_ticket_status_id = user?.int_task_def_ticket_status_id || null;
    const task_def_ticket_status_id = user?.task_def_ticket_status_id || null;

    const [taskChecklists, setTaskChecklists] = useState<TaskChecklistRow[]>(item?.checklists ? objectClone(item.checklists) : []);
    const [productsS, setProductsS] = useState<MultiSelectOption<number>[]>([]);
    const [productsH, setProductsH] = useState<MultiSelectOption<number>[]>([]);
    const [customerContacts, setCustomerContacts] = useState<MultiSelectOption<number>[]>([]);
    const [observers, setObservers] = useState<MultiSelectOption<number>[]>([]);
    const [attachmentsRemoved, setAttachmentsRemoved] = useState<AttachmentTaskRow[]>([]);
    const [checklistsRemoved, setChecklistsRemoved] = useState<TaskChecklistRow[]>([]);
    const [attachmentsEditingIdx, setAttachmentsEditingIdx] = useState<number | null>(null);
    const [attachmentDescriptionDialogOpen, setAttachmentDescriptionDialogOpen] = useState<boolean>(false);
    const [commentDialogOpen, setCommentDialogOpen] = useState<boolean>(false);
    const [firmwareDialogOpen, setFirmwareDialogOpen] = useState<boolean>(false);
    const [reminderDialogOpen, setReminderDialogOpen] = useState<{ days: number | null, open: boolean }>({ days: null, open: false });
    const [addChecklistDialogOpen, setAddChecklistDialogOpen] = useState<boolean>(false);
    const [addReferenceDialogOpen, setAddReferenceDialogOpen] = useState<boolean>(false);
    const [attachmentPasteDialogOpen, setAttachmentPasteDialogOpen] = useState<boolean>(false);
    const [isDirty, setDirty] = useState<boolean>(false);
    const [isFieldsMandatoryByTicketStatus, setIsFieldsMandatoryByTicketStatus] = useState<boolean>(false);
    const [isDisableComment, setIsDisableComment] = useState<boolean>(false);
    const [isScheduled, setIsScheduled] = useState<boolean>(false);
    const [clipboardDataTask, setClipboardDataTask] = useState<FileList | null>(null);
    const commentDialogOpenRef = useRef<boolean>(false);
    commentDialogOpenRef.current = commentDialogOpen;
    const formRef = useRef<Form<TaskFormData>>(null);
    const [taskReminders, setTaskReminders] = useState<Partial<TaskReminder>[]>([]);
    const [newFirmwares, setNewFirmwares] = useState<FirmwareFormDialogData[]>([]);
    const [newFirmwaresLinks, setNewFirmwaresLinks] = useState<number[]>([]);
    const [projectCreateDialogOpen, setProjectCreateDialogOpen] = useState<boolean>(false);
    const [projectCreateInitialValues, setProjectCreateInitialValues] = useState<ProjectQuickCreateFormData>({
        name: '',
        ticket_status_id: null,
        user_id: null,
        product_line_id: null,
        observers: [],
        description: '',
        description_report: ''
    });
    const [isSavingProject, setIsSavingProject] = useState<boolean>(false);
    const [projectSearchKey, setProjectSearchKey] = useState<number>(0);
    const [closeConfirmationOpen, setCloseConfirmationOpen] = useState<boolean>(false);
    const [closeConfirmationContext, setCloseConfirmationContext] = useState<CloseConfirmationContext | null>(null);
    const [iaSuggestions, setIaSuggestions] = useState<string[]>([]);
    const [iaSuggestionsLoading, setIaSuggestionsLoading] = useState<boolean>(false);

    const [integratorId, setIntegratorId] = useState<number | null>(null);
    const [finalCustomerTaskObservation, setFinalCustomerTaskObservation] = useState<string>('');
    const [finalCustomerTaskObservationDialogOpen, setFinalCustomerTaskObservationDialogOpen] = useState<boolean>(false);
    const [integratorTaskObservation, setIntegratorTaskObservation] = useState<string>('');
    const [integratorTaskObservationDialogOpen, setIntegratorTaskObservationDialogOpen] = useState<boolean>(false);

    // Contract states
    const [finalCustomerContracts, setFinalCustomerContracts] = useState<FinalCustomerContract[]>([]);
    const [finalCustomerContractsStatus, setFinalCustomerContractsStatus] = useState<'none' | 'ok' | 'warning' | 'loading'>('loading');
    const [finalCustomerContractsDialogOpen, setFinalCustomerContractsDialogOpen] = useState<boolean>(false);

    const [showLanzaBotConclued, setShowLanzaBotConclued] = useState<boolean>(false);
    const [ticketTypeApprovers, setTicketTypeApprovers] = useState<User[]>([]);

    const [relatedUsers, setRelatedUsers] = useState<User[]>([]);

    const [heightDescription, setHeightDescription] = useState<number>(165);
    const [heightSolution, setHeightSolution] = useState<number>(165);

    const [tagSuggestions, setTagSuggestions] = useState<ReactTagsData[]>([]);

    const [isActualTicketStatusClosed, setIsActualTicketStatusClosed] = useState<boolean>(false);

    const [rulesByTicketType, setRulesByTicketType] = useState<RulesByTicketType>({
        ticket_status_ids: [],
        rule_tag: TicketLayoutTypeRule.Optional,
        rule_final_customer: TicketLayoutTypeRule.Optional,
        rule_require_attachment_development: TicketLayoutTypeRule.Optional,
        rule_origin: TicketLayoutTypeRule.Optional,
        rule_client_contacts: TicketLayoutTypeRule.Optional,
        rule_post_service_tab: TicketLayoutTypeRule.Optional,
        rule_effort_estimate: TicketLayoutTypeRule.Optional,
        rule_delivery_forecast: TicketLayoutTypeRule.Optional,
        rule_quantity_to_be_produced: TicketLayoutTypeRule.Optional,
        rule_last_status_update: TicketLayoutTypeRule.Optional,
        rule_attachment_client: TicketLayoutTypeRule.Optional,
        rule_attachment_analysis: TicketLayoutTypeRule.Optional,
        rule_attachment_solution: TicketLayoutTypeRule.Optional,
        rule_checklist: TicketLayoutTypeRule.Optional,
        rule_comment_attachment: TicketLayoutTypeRule.Optional,
        rule_comment_reminder: TicketLayoutTypeRule.Optional,
        loaded: false,
        ticket_type_id: null
    });

    useEffect(() => {
        window.addEventListener('paste', onPasteHandlerTask);
        apiUser.getList({ order: { name: 'ASC' }, where: [['type', '=', UserType.Commbox], ['active', '=', true]] }).then((users) => {
            setObservers(users.map((user) => { return { value: user.id, label: user.name } }));
        });
        loadRulesByTicketType(item?.ticket_type_id ? item?.ticket_type_id : (isInternal && int_task_def_ticket_type_id ? int_task_def_ticket_type_id : null));
        setRulesByStatus(item?.ticket_status_id, true);
        fetchDataByFinalCustomer(item?.final_customer_id || finalCustomerId, true);

        apiTag.getList({ order: { name: 'ASC' }, where: [['type', '=', TagType.Task]] }).then(suggestions => {
            setTagSuggestions(suggestions.map((tag) => { return { id: String(tag.id), text: tag.name } }));
        });

        fillRelatedUsers();

        if (item?.description) {
            let countLinesDescription = item.description.split(/\r?\n/).length;
            if (countLinesDescription > 7) {
                if (countLinesDescription > 9) {
                    setHeightDescription(225);
                } else if (countLinesDescription > 8) {
                    setHeightDescription(205);
                } else {
                    setHeightDescription(185);
                }
            }
        }

        if (item?.solution) {
            let countLinesSolution = item.solution.split(/\r?\n/).length;
            if (countLinesSolution > 7) {
                if (countLinesSolution > 9) {
                    setHeightSolution(225);
                } else if (countLinesSolution > 8) {
                    setHeightSolution(205);
                } else {
                    setHeightSolution(185);
                }
            }
        }

        return () => {
            window.removeEventListener('paste', onPasteHandlerTask);
        }
    }, []);

    function fillRelatedUsers(newUser?: User) {
        let relatedUsersTemp: User[] = [];
        if (item) {
            if (newUser && newUser.perm_task) {
                relatedUsersTemp.push(newUser);
            } else {
                if (item.user && item.user.perm_task) {
                    let permsByDpItemUser = getUserDepartmentPermissions(item.user);
                    if (permsByDpItemUser.perm_menu_tasks || isInternal) {
                        relatedUsersTemp.push(item.user);
                    }
                }
            }
            if (item.created_by_user && item.created_by_user.perm_task && relatedUsersTemp.findIndex(u => u.id === item.created_by_user_id) === -1) {
                let permsByDpCreatedBy = getUserDepartmentPermissions(item.created_by_user);
                if (permsByDpCreatedBy.perm_menu_tasks || isInternal) {
                    relatedUsersTemp.push(item.created_by_user);
                }
            }
            item.comments?.forEach(comment => {
                if (comment.user?.name === 'LanzaBot') return;
                if (comment.user && comment.user.perm_task && relatedUsersTemp.findIndex(u => u.id === comment.user_id) === -1) {
                    let permsByDpCommentUser = getUserDepartmentPermissions(comment.user);
                    if (permsByDpCommentUser.perm_menu_tasks || isInternal) {
                        relatedUsersTemp.push(comment.user);
                    }
                }
                comment.comment_task_users?.forEach(commentTaskUser => {
                    if (commentTaskUser.user && commentTaskUser.user.perm_task && relatedUsersTemp.findIndex(u => u.id === commentTaskUser.user_id) === -1) {
                        let permsByDpCommentTaskUser = getUserDepartmentPermissions(commentTaskUser.user);
                        if (permsByDpCommentTaskUser.perm_menu_tasks || isInternal) {
                            relatedUsersTemp.push(commentTaskUser.user);
                        }
                    }
                });
            });
        }
        setRelatedUsers(relatedUsersTemp);
    }

    function downloadPdf(taskId: string | number, pdfName: string) {
        api.getBlobPdf(taskId).then((blobData) => {
            if (blobData) {
                var url = window.URL.createObjectURL(blobData);
                var a = document.createElement('a');
                a.href = url;
                a.download = `${pdfName}.pdf`;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again       
            }
        });
    }

    function onPasteHandlerTask(evt: ClipboardEvent | Event) {
        const clipboardItems = (evt as ClipboardEvent).clipboardData?.items;
        if (!clipboardItems) {
            return;
        }
        const container = new DataTransfer();
        for (const item of Array.from(clipboardItems)) {
            let blob = item.getAsFile();

            if (!blob) continue;

            /*let imageEle = document.getElementById('preview') as HTMLImageElement;
            if (imageEle && blob) {
                imageEle.src = URL.createObjectURL(blob);
            }*/

            let file = new File([blob], blob.name, {
                type: blob.type,
                lastModified: new Date().getTime()
            });
            container.items.add(file);
        }

        if (container.files.length === 0) return;
        evt.preventDefault();
        evt.stopPropagation();
        if (commentDialogOpenRef.current === true) {
            if (rulesByTicketType.rule_comment_attachment !== TicketLayoutTypeRule.NotVisible) {
                onPasteHandlerContinue(container.files, 'comment_attachment');
            }
        } else if (!allow_edit_task_gen_att_cli && !allow_edit_task_resolution) {
            if (rulesByTicketType.rule_attachment_analysis !== TicketLayoutTypeRule.NotVisible) {
                onPasteHandlerContinue(container.files, 'attachment-task-2');
            }
        } else {
            if (rulesByTicketType.rule_attachment_analysis !== TicketLayoutTypeRule.NotVisible ||
                rulesByTicketType.rule_attachment_solution !== TicketLayoutTypeRule.NotVisible ||
                rulesByTicketType.rule_attachment_client !== TicketLayoutTypeRule.NotVisible) {
                setClipboardDataTask(container.files);
                setAttachmentPasteDialogOpen(true);
            }
        }
    }

    function resetCloseConfirmationState() {
        setCloseConfirmationOpen(false);
        setCloseConfirmationContext(null);
        setIaSuggestions([]);
        setIaSuggestionsLoading(false);
    }

    async function requestIaSuggestions(description: string | null, solution: string | null, comments: string | null) {
        try {
            setIaSuggestionsLoading(true);
            const suggestions = await api.iaCloseSuggestions(description, solution, comments);
            setIaSuggestions(suggestions || []);
        } catch (error) {
            console.error('Erro ao buscar sugestões com IA', error);
            enqueueSnackbar('Não foi possível buscar sugestões com LanzaBot.', { variant: 'error' });
        } finally {
            setIaSuggestionsLoading(false);
        }
    }

    async function handleTicketTypeChange(v: number | null, formValues: TaskFormData, setFieldValue: any) {
        await setFieldValue('ticket_type_id', v);
        await setFieldValue('type_has_changed', initialValues.ticket_type_id !== v);
        await loadRulesByTicketType(v, setFieldValue, formValues);
    }

    function onPasteHandlerContinue(clipboardItems: FileList | null, inputId: string) {
        if (!clipboardItems) {
            setAttachmentPasteDialogOpen(false);
            return;
        }

        const fileInput = document.querySelector<HTMLInputElement>('#' + inputId);
        if (fileInput) {
            fileInput.files = clipboardItems;

            // Trigger the onChange event
            const event = new Event('change', { bubbles: true });
            fileInput.dispatchEvent(event);
        }
        setAttachmentPasteDialogOpen(false);
    }

    async function fetchDataByFinalCustomer(final_customer_id?: number | null, loadingTask?: boolean, setFieldValue?: any) {
        if (final_customer_id) {
            // Fetch contracts for non-internal users
            if (!isInternal) {
                fetchFinalCustomerContracts(final_customer_id);
            }
            const finalCustomer = await apiFinalCustomer.getById(final_customer_id, { relations: ['products', 'users', 'integrator', 'integrator.users'] });
            let prod = finalCustomer.products;
            if (prod && prod.length > 0) {
                setProductsS(prod.filter((p) => p.type === ProductType.Software).map((c) => { return { value: c.id, label: c.name } }));
                setProductsH(prod.filter((p) => p.type === ProductType.Hardware).map((c) => { return { value: c.id, label: c.name } }));
            }

            let users = [...(finalCustomer.users || []), ...(finalCustomer.integrator?.users || [])];
            let usersSorted = sortObjectArrayByProp(users, 'name');

            let autoUseContactUsers: number[] = [];
            setCustomerContacts(usersSorted.map((c) => {
                let userName = `${c.name}`;
                if (c.type === UserType.Integrator) {
                    userName += ` (integrador)`;
                } else if (c.type === UserType.FinalCustomer) {
                    userName += ` (cliente)`;
                } else {
                    userName += ` (commbox)`;
                }
                if (c.auto_use_contact) {
                    autoUseContactUsers.push(c.id);
                }
                return { value: c.id, label: userName, disabled: c.auto_use_contact === 2 };
            }));

            if (!loadingTask && setFieldValue) {
                setFieldValue('customer_contacts', autoUseContactUsers);
            }

            setIntegratorId(finalCustomer.integrator_id || null);
            setFinalCustomerTaskObservation(finalCustomer.task_observation || '');
            setIntegratorTaskObservation(finalCustomer.integrator?.task_observation || '');
        } else {
            // Reset contracts
            if (!isInternal) {
                setFinalCustomerContracts([]);
                setFinalCustomerContractsStatus('none');
            }
            setProductsS([]);
            setProductsH([]);
            setCustomerContacts([]);
            setIntegratorId(null);
            setFinalCustomerTaskObservation('');
            setIntegratorTaskObservation('');
        }
    }

    async function fetchFinalCustomerContracts(final_customer_id: number) {
        setFinalCustomerContractsStatus('loading');
        try {
            const contracts = await apiFinalCustomerContract.getList({
                where: [['final_customer_id', '=', final_customer_id]],
                order: { expires_at: 'DESC' }
            });
            setFinalCustomerContracts(contracts);

            if (contracts.length === 0) {
                // No contracts - red
                setFinalCustomerContractsStatus('none');
            } else {
                const today = moment().startOf('day');
                // Check if ALL contracts are active, not blocked, and not expired
                const allContractsValid = contracts.every(contract => {
                    const isActive = contract.status === FinalCustomerContractStatus.Ativo;
                    const isNotBlocked = !contract.blocked;
                    const expiresAt = contract.expires_at ? moment(contract.expires_at) : null;
                    const isNotExpired = !expiresAt || expiresAt.isSameOrAfter(today, 'day');
                    return isActive && isNotBlocked && isNotExpired;
                });

                if (allContractsValid) {
                    // All contracts are valid - green
                    setFinalCustomerContractsStatus('ok');
                } else {
                    // Has at least one expired or blocked contract - orange
                    setFinalCustomerContractsStatus('warning');
                }
            }
        } catch (error) {
            console.error('Error fetching contracts:', error);
            setFinalCustomerContracts([]);
            setFinalCustomerContractsStatus('none');
        }
    }

    function getContractStatusColor(): string {
        switch (finalCustomerContractsStatus) {
            case 'ok':
                return '#4caf50'; // green
            case 'warning':
                return '#ff9800'; // orange
            case 'none':
                return '#f44336'; // red
            case 'loading':
                return 'inherit';
            default:
                return 'inherit';
        }
    }

    function getContractStatusTooltip(): string {
        switch (finalCustomerContractsStatus) {
            case 'ok':
                return 'Cliente possui contrato ativo';
            case 'warning':
                return 'Cliente possui contrato vencido ou bloqueado';
            case 'none':
                return finalCustomerContracts.length === 0 ? 'Cliente sem contrato' : 'Cliente sem contrato ativo';
            case 'loading':
                return 'Carregando contratos...';
            default:
                return 'Contratos do cliente';
        }
    }

    function productLineTitle(pl?: FinalCustomerContractProductLine): string {
        switch (pl) {
            case FinalCustomerContractProductLine.ControleDeAcesso: return 'Acesso';
            case FinalCustomerContractProductLine.ControleDeAcessoLite: return 'Acesso Lite';
            case FinalCustomerContractProductLine.Alarme: return 'Alarme';
            case FinalCustomerContractProductLine.PSIM: return 'PSIM';
            case FinalCustomerContractProductLine.ControleDeDataCenter: return 'Data Center';
            case FinalCustomerContractProductLine.AutomacaoIP: return 'Automação IP';
            case FinalCustomerContractProductLine.GeradorDeNevoa: return 'Gerador de Névoa';
            case FinalCustomerContractProductLine.Portal: return 'Portal';
            case FinalCustomerContractProductLine.CIP: return 'CIP';
            default: return '-';
        }
    }

    function serviceTypeTitle(st?: FinalCustomerContractServiceType): string {
        switch (st) {
            case FinalCustomerContractServiceType.SuporteDeSoftware: return 'Suporte de Software';
            case FinalCustomerContractServiceType.LocacaoDeSoftware: return 'Locação de Software';
            case FinalCustomerContractServiceType.LocacaoDeSoftwareEHardware: return 'Locação de SW + HW';
            case FinalCustomerContractServiceType.POC: return 'POC';
            case FinalCustomerContractServiceType.Garantia: return 'Garantia';
            default: return '-';
        }
    }

    const initialValues: TaskFormData = {
        name: item?.name || '',
        description: item?.description || '',
        solution: item?.solution || '',
        ticket_status_id: item?.ticket_status_id ? item?.ticket_status_id : (isInternal ? (int_task_def_ticket_status_id ? int_task_def_ticket_status_id : null) : (task_def_ticket_status_id ? task_def_ticket_status_id : null)),
        project_id: item?.project_id || projectId || null,
        user_id: item?.user_id ? item?.user_id : ((!disable_task_auto_assign && user) ? user.id : null),
        final_customer_id: item?.final_customer_id || finalCustomerId || null,
        ticket_type_id: item?.ticket_type_id ? item?.ticket_type_id : (isInternal && int_task_def_ticket_type_id ? int_task_def_ticket_type_id : null),
        ticket_root_cause_id: item?.ticket_root_cause_id || null,
        ticket_cause_id: item?.ticket_cause_id || null,
        ticket_origin_id: item?.ticket_origin_id || null,
        ticket_solution_type_id: item?.ticket_solution_type_id || null,
        products_s: item?.products ? item.products.filter((p) => p.type === ProductType.Software).map(c => c.id) : [],
        products_h: item?.products ? item.products.filter((p) => p.type === ProductType.Hardware).map(c => c.id) : [],
        customer_contacts: item?.customer_contacts ? item.customer_contacts.map(c => c.id) : [],
        observers: item?.observers ? item.observers.map(c => c.id) : [],
        comments: item?.comments?.filter(c => c.type === CommentTaskType.PreService) || [],
        attachments: item?.attachments ? objectClone(item?.attachments) : [],
        delivery_forecast: item?.delivery_forecast ? new Date(item?.delivery_forecast) : null,
        scheduled_date: item?.scheduled_date ? new Date(item?.scheduled_date) : null,
        effort_estimation: item?.effort_estimation || '',
        priority: item?.priority || null,
        required_dev_attach: item?.required_dev_attach || false,
        solution_time: null,
        tags: item?.tags ? item.tags.map(t => { return { id: String(t.id), text: t.name } }) : [],
        checklists: item?.checklists ? objectClone(item?.checklists) : [],
        technical_assistances: item?.technical_assistances ? item.technical_assistances : [],
        prod_amount_to_be_produced: item?.prod_amount_to_be_produced || null,
        references: item?.references ? objectClone(item.references) : [],
        type_has_changed: item?.type_has_changed || false,
        feedback_to_improve_item: item?.feedback_to_improve_item || null,
        feedback_to_improve_text: item?.feedback_to_improve_text || null
    };

    function getValidationSchema() {
        const validationSchema: FormValidationSchema<TaskFormData> = {
            name: Yup.string()
                .trim()
                .required()
                .min(3)
                .max(80)
                .label('Assunto'),
            description: Yup.string()
                .trim()
                .required()
                .label('Descrição'),
            ticket_status_id: Yup.number()
                .required()
                .label('Status'),
            final_customer_id: Yup.number()
                .required()
                .label('Cliente final'),
            ticket_type_id: Yup.number()
                .required()
                .label('Tipo'),
            solution_time: Yup
                .string()
                .nullable()
                .matches(/^(44:00|([0-3][0-9]|[0-9]|4[0-3]):[0-5][0-9])?$|^$/, 'Tempo inválido. Tempo máximo de 44 horas')
                .label('Registrar tempo')
        }

        if (isInternal) {
            validationSchema.priority = Yup.number()
                .required()
                .min(1)
                .max(999)
                .label('Prioridade');
        }

        if (isFieldsMandatoryByTicketStatus === true) {
            validationSchema.solution = Yup.string()
                .trim()
                .required()
                .label('Solução');
            validationSchema.ticket_solution_type_id = Yup.number()
                .required()
                .label('Tipo de solução');
            validationSchema.ticket_cause_id = Yup.number()
                .required()
                .label('Causa');
        }

        return validationSchema;
    }

    async function onSubmitHandler(values: TaskFormData, dirty: FormDirty<TaskFormData>, errors?: FormErrors<TaskFormData>, submitType?: string | null,
        proceedCommentStatus?: boolean, proceedAddTag?: boolean, proceedStatusLimit?: boolean, proceedCloseConfirmation?: boolean) {
        const isDirty = Object.values(dirty).reduce((p, c) => p || c, false);
        var requireStatusComment = false;

        if (errors) {
            for (var error of Object.values(errors).filter(e => !!e)) {
                enqueueSnackbar(error, { variant: 'error' });
            }
            return;
        }

        if (values.ticket_type_id === FixedIds.ticketTypeFalhaHardware && values.technical_assistances.length === 0) {
            enqueueSnackbar("É obrigatório adicionar ao menos uma assistência técnica.", { variant: 'error', autoHideDuration: 10000 });
            return;
        }

        if (item?.id && !proceedCommentStatus && !proceedAddTag && !proceedStatusLimit && !proceedCloseConfirmation) {
            const countHasUpdated = await api.count({ where: [['id', '=', item.id], ['updated_at', '>', moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss.SSS')]] });
            if (countHasUpdated > 0) {
                enqueueSnackbar("Esse registro foi alterado por outro usuário. É necessário recarregar a página.", { variant: 'error', autoHideDuration: 10000 });
                return;
            }
        }

        if (values.tags.length === 0 && rulesByTicketType.rule_tag === TicketLayoutTypeRule.Required) {
            enqueueSnackbar("É obrigatório adicionar no mínimo 1 TAG.", { variant: 'error', autoHideDuration: 10000 });
            return;
        }

        const isStatusChanged = !!item?.id && initialValues.ticket_status_id !== values.ticket_status_id;

        const isUserChanged = initialValues.user_id !== values.user_id;

        var sendEmailStatusClosed = false;

        const isInternal = commboxId === values.final_customer_id;
        var newTicketStatus: TicketStatus | null = null;

        var requireCommentStatusLimit = false;
        var tasksToPause: Task[] = [];
        var requireCloseConfirmation = false;

        if (values.ticket_status_id) {
            newTicketStatus = await apiTicketStatus.getById(values.ticket_status_id, { relations: ['require_task_comment_user'] });

            if (newTicketStatus.closed && taskChecklists.filter(tc => ((!tc.not_filled || tc.is_mandatory) && tc.task_checklist_items?.length !== tc.checklist?.checklist_items.length)).length > 0) {
                enqueueSnackbar("Existem checklists não preenchidos.", { variant: 'error', autoHideDuration: 8000 });
                return;
            }

            if (isUserChanged && newTicketStatus.in_progress && values.user_id !== user?.id) {
                enqueueSnackbar("Não é permitido transferir uma tarefa com status em andamento.", { variant: 'error', autoHideDuration: 8000 });
                return;
            }

            if (isStatusChanged && newTicketStatus.in_progress && values.user_id !== user?.id) {
                enqueueSnackbar("Não é permitido alterar a tarefa de outro usuário para um status em andamento.", { variant: 'error', autoHideDuration: 8000 });
                return;
            }

            if (values.user_id) {
                if (newTicketStatus.almost_closed === true || newTicketStatus.closed === true) {
                    if (values.required_dev_attach === true && values.attachments.filter(a => a.type === AttachmentTaskType.Analysis).length === 0) {
                        enqueueSnackbar("É obrigatório adicionar no mínimo 1 anexo de desenvolvimento.", { variant: 'error' });
                        return;
                    }
                }
                if (newTicketStatus.almost_closed === true) {
                    const userAssigned = await apiUser.getById(values.user_id);
                    if (userAssigned.allow_edit_task_resolution !== true && userAssigned.id !== item?.created_by_user_id) {
                        enqueueSnackbar("O usuário que está sendo atribuído, não tem permissão para fechar o chamado. Altere o status ou o usuário.", { variant: 'error' });
                        return;
                    }
                }

                if ((isStatusChanged || isUserChanged) && newTicketStatus.max_task_internal && newTicketStatus.max_task_internal > 0 && isInternal) {
                    const listTasksByStatus = await api.getList({ where: [['ticket_status_id', '=', values.ticket_status_id], ['user_id', '=', values.user_id], ['final_customer_id', '=', commboxId]] });
                    if (listTasksByStatus.length >= newTicketStatus.max_task_internal) {
                        if (values.user_id === user?.id) {
                            requireCommentStatusLimit = true;
                            tasksToPause = listTasksByStatus;
                        } else {
                            enqueueSnackbar("O usuário atribuído não pode receber mais demandas com esse status.", { variant: 'error', autoHideDuration: 8000 });
                            return;
                        }
                    }
                }
            }

            var oldTicketStatus: TicketStatus | null = newTicketStatus;

            if (isStatusChanged && initialValues.ticket_status_id) {
                if (newTicketStatus.require_task_comment && !requireCommentStatusLimit) {
                    requireStatusComment = true;
                }

                oldTicketStatus = await apiTicketStatus.getById(initialValues.ticket_status_id);
                sendEmailStatusClosed = oldTicketStatus.closed !== newTicketStatus.closed;
            }

            if (oldTicketStatus && oldTicketStatus.disable_comment && newTicketStatus.disable_comment && values.comments.filter(c => c.id === 0).length > 0 && !proceedCloseConfirmation) {
                enqueueSnackbar("O status do chamado não permite adicionar novos comentários.", { variant: 'error' });
                return;
            }

            if (values.technical_assistances.length > 0 && newTicketStatus.closed) {
                if (values.technical_assistances.filter(ta => ta.ticket_status?.closed === true).length !== values.technical_assistances.length) {
                    enqueueSnackbar("Todas as assistências técnicas devem estar concluídas ou canceladas para encerrar o chamado.", { variant: 'error' });
                    return;
                }
            }

            if (!isInternal && isStatusChanged && newTicketStatus.closed && item?.id) {
                requireCloseConfirmation = true;
            }
        }

        let oldUserId = initialValues.user_id && initialValues.user_id !== values.user_id ? initialValues.user_id : undefined;

        let alteradoParaDesenvolvidoAnalisado = !!isStatusChanged && values.ticket_status_id === FixedIds.ticketStatusDesenvolvidoAnalisado;

        if (requireStatusComment && newTicketStatus && !proceedCommentStatus) {
            taskStatusChangeCommentDialog({
                // onProceed: async () => await onSubmit(values, attachmentsRemoved, isDirty, sendEmailStatusClosed, submitType, oldUserId,
                //     isInternal, isStatusChanged, initialValues.ticket_status_id, taskReminders, initialValues.project_id, checklistsRemoved, newFirmwares, newFirmwaresLinks),
                onProceed: async () => await onSubmitHandler(values, dirty, undefined, submitType, true, proceedAddTag, proceedStatusLimit),
                user_id: newTicketStatus.require_task_comment_user?.id,
                user_name: newTicketStatus.require_task_comment_user?.name,
                task_id: item?.id || 0,
                auth_user_id: user?.id || 0
            });
        } else if (!proceedAddTag && !!alteradoParaDesenvolvidoAnalisado) {
            taskAddTagDialog({
                onProceed: async (taskAddTagDialogFormData) => {
                    if (taskAddTagDialogFormData?.tags) {
                        taskAddTagDialogFormData.tags.forEach(tag => {
                            if (!values.tags.some(t => t.text === tag.text)) {
                                values.tags.push(tag);
                            }
                        });
                    }
                    if(taskAddTagDialogFormData?.ticket_root_cause_id){
                        values.ticket_root_cause_id = taskAddTagDialogFormData.ticket_root_cause_id;
                    }
                    await onSubmitHandler(values, dirty, undefined, submitType, proceedCommentStatus, true, proceedStatusLimit)
                },
                user_name: user?.name || '',
                task_id: item?.id || 0,
                enqueueSnackbar
            });
        } else if (!proceedStatusLimit && requireCommentStatusLimit && item) {
            taskPauseCommentDialog({
                onProceed: async () => await onSubmitHandler(values, dirty, undefined, submitType, true, proceedAddTag, proceedStatusLimit),
                user_id: user?.id || 0,
                tasks: tasksToPause,
                newTask: item
            });
        } else if (!proceedCloseConfirmation && requireCloseConfirmation) {
            setCloseConfirmationContext({ submitType, proceedCommentStatus, proceedAddTag, proceedStatusLimit });
            setIaSuggestions([]);
            setIaSuggestionsLoading(false);
            setCloseConfirmationOpen(true);
            return;
        } else {
            await onSubmit(values, attachmentsRemoved, isDirty, sendEmailStatusClosed, submitType, oldUserId,
                isInternal, isStatusChanged, initialValues.ticket_status_id, taskReminders, initialValues.project_id, checklistsRemoved, newFirmwares, newFirmwaresLinks);
        }
    }

    async function validateTaskUpdatedAt() {
        if (item?.id) {
            const countHasUpdated = await api.count({ where: [['id', '=', item.id], ['updated_at', '>', moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss.SSS')]] });
            if (countHasUpdated > 0) {
                enqueueSnackbar("Esse registro foi alterado por outro usuário. É necessário recarregar a página.", { variant: 'error', autoHideDuration: 10000 });
                return false;
            }
        }
        return true;
    }

    function addAttachment(attachments: AttachmentTaskRow[], type: AttachmentTaskType, setFieldValue: any, name: string, file?: File, commentIdx?: number, system_attachment_id?: number | null, system_attachment?: any) {
        if (attachments.filter((a) => a.type === type).length < 30) {
            attachments.push({ id: 0, description: '', name, type, file, commentIdx, system_attachment_id, system_attachment });
            setFieldValue('attachments', attachments);
        } else {
            enqueueSnackbar("Limite de 30 anexos atingido.", { variant: 'error', preventDuplicate: true });
        }
    }

    function removeAttachment(idx: number, attachments: AttachmentTaskRow[], setFieldValue: any) {
        let attachment = attachments.find((o, i) => i === idx);
        setFieldValue('attachments', attachments.filter((o, i) => i !== idx));
        if (attachment && attachment.id > 0) {
            attachmentsRemoved.push(attachment);
            setAttachmentsRemoved(attachmentsRemoved);
        }
    }

    async function downloadAttachment(fileName: string, systemAttachmentId?: number | null, systemAttachmentFile?: string) {
        if (systemAttachmentId && systemAttachmentFile) {
            let dir = `SystemAttachment/${systemAttachmentId}/${systemAttachmentFile}`;
            await downloadBlob(dir, fileName);
        } else {
            let dir = `Task/${item?.id}/${fileName}`;
            await downloadBlob(dir, fileName);
        }
    }

    function openAttachmentDescriptionDialog(idx: number) {
        setAttachmentsEditingIdx(idx);
        setAttachmentDescriptionDialogOpen(true);
    }

    function closeAttachmentDescriptionDialog() {
        setAttachmentsEditingIdx(null);
        setAttachmentDescriptionDialogOpen(false);
    }

    function submitAttachmentDescriptionDialog(setFieldValue: any, attachments: AttachmentTaskRow[], description: string, idx: number | null) {
        if (idx === null) return;
        attachments[idx].description = description;
        attachments[idx].edited = true;
        setFieldValue('attachments', attachments);
        setAttachmentDescriptionDialogOpen(false);
        setAttachmentsEditingIdx(null);
    }

    function openFirmwareDialog() {
        setFirmwareDialogOpen(true);
    }

    function closeFirmwareDialog() {
        setFirmwareDialogOpen(false);
    }

    function openCommentDialog() {
        if (commentDialogOpenRef.current) {
            return;
        }
        setCommentDialogOpen(true);
    }

    function closeCommentDialog() {
        setCommentDialogOpen(false);
    }

    function openReminderDialog(days: number | null) {
        setReminderDialogOpen({ days: days, open: true });
    }

    function closeReminderDialog() {
        setReminderDialogOpen({ days: null, open: false });
    }

    async function submitFirmwareDialog(setFieldValue: any, comments: CommentTask[], data: FirmwareFormDialogData, software: Software | null) {
        if (!software) {
            setNewFirmwares((o) => {
                return [...o, data];
            });
        } else {
            setNewFirmwaresLinks((o) => {
                return [...o, software.id];
            })
        }
        let comment = `Novo firmware adicionado - ${software ? software.name : data.name} (versão ${software ? software.version : data.version})\n`;
        comment += `Funcionalidades: ${software ? software.new_features : data.new_features}\n`;
        comment += `Correções Realizadas: ${software ? software.corrections_made : data.corrections_made}\n`;
        comment += `Observações gerais: ${software ? software.general_observations : data.general_observations}\n\n`;
        if (!software) {
            comment += `{[LINK_FIRMWARE_${data.name}_${data.version}]}`;
        } else {
            comment += `<a href="http://safedesk.commbox.com.br/#/system/administration/software/${software.id}/general" target="_blank">http://safedesk.commbox.com.br/#/system/administration/software/${software.id}/general</a>`;
        }
        await submitCommentDialog(setFieldValue, comments, comment, false, undefined, [FixedIds.idBruno, FixedIds.idHenrique, FixedIds.idMarcio]);
        setFirmwareDialogOpen(false);
    }

    async function submitReminderDialog(setFieldValue: any, comments: CommentTask[], comment: string, reminder_date: Date, reminderUsers: OptionItem<number>[]) {
        const lanzaBotList = await apiUser.getList({ where: [['name', '=', 'LanzaBot']] });
        if (lanzaBotList.length > 0 && user) {
            const taskReminder: Partial<TaskReminder> = {
                comment: comment,
                reminder_date: moment(reminder_date).format('YYYY-MM-DD HH:mm:00'),
                user_id: user.id,
                user_ids: reminderUsers.map(u => u.value)
            }
            taskReminders.push(taskReminder);
            setTaskReminders(taskReminders);
            let textUsers = reminderUsers.map(u => u.label).join(', ');
            //replace a virgula da ultima posicao por 'e '
            textUsers = textUsers.replace(/,([^,]*)$/, ' e$1');
            if (reminderUsers.length > 1) {
                textUsers = `para os usuários ${textUsers}`;
            } else {
                textUsers = `para o usuário ${textUsers}`;
            }
            submitCommentDialog(setFieldValue, comments, `Lembrete adicionado por ${user.name} ${textUsers}, para o dia ${moment(reminder_date).format('DD/MM/YYYY [ás] HH:mm')}`, false, undefined, undefined, undefined, undefined, lanzaBotList[0]);
        }
        setReminderDialogOpen({ days: null, open: false });
    }

    async function submitCommentDialog(setFieldValue: any, comments: CommentTask[], comment: string, is_public: boolean, time?: string, assigned_users?: number[] | null,
        newAttachments?: AttachmentTask[], attachments?: AttachmentTaskRow[], forceUser?: User, transfer_task?: boolean, transfer_task_user_id?: number | null,
        reminder_date?: Date | null, prod_amount?: number | null, prod_amount_problem?: number | null, send_comment_to_approver?: boolean, notify_others_users?: number[] | null) {
        if (comment.trim() !== '') {
            var commentTaskUsers: CommentTaskUser[] | undefined = undefined;
            if (assigned_users && assigned_users.length > 0) {
                const users = await apiUser.getList({ where: [['id', 'in', assigned_users]], order: { name: 'ASC' } });
                if (users && users.length > 0) {
                    commentTaskUsers = users.map(u => { return { id: 0, comment_task_id: 0, user_id: u.id, user: u } });
                }
            }
            var notifyUsers: User[] | undefined = undefined;
            if (notify_others_users && notify_others_users.length > 0) {
                const users = await apiUser.getList({ where: [['id', 'in', notify_others_users]], order: { name: 'ASC' } });
                if (users && users.length > 0) {
                    notifyUsers = users;
                }
            }
            let newComment: CommentTask = {
                id: 0,
                comment,
                user_id: forceUser ? forceUser.id : (user?.id ? user?.id : 0),
                user: forceUser ? forceUser : undefined,
                is_public,
                type: CommentTaskType.PreService,
                comment_task_users: commentTaskUsers,
                prod_amount: prod_amount || 0,
                prod_amount_problem: prod_amount_problem || 0,
                notify_others_users: notifyUsers,
                send_comment_to_approver: send_comment_to_approver || false
            };
            if (time) {
                var [hours, minutes] = time.split(':');
                if (hours || minutes) {
                    newComment.time_counter = {
                        id: 0, hours: hours ? parseInt(hours) : 0,
                        minutes: minutes ? parseInt(minutes) : 0, task_id: 0, user_id: 0, comment_task_id: 0
                    };
                }
            }
            let commentIdx = comments.push(newComment);
            commentIdx = commentIdx - 1;
            eventEmmiter.emit('newComment', newComment);
            await setFieldValue('comments', comments);

            if (transfer_task && transfer_task_user_id) {
                await setFieldValue('user_id', transfer_task_user_id);
            }

            if (attachments && newAttachments && newAttachments.length > 0) {
                newAttachments.forEach(attachment => {
                    addAttachment(attachments, attachment.type, setFieldValue, attachment.name, attachment.file, commentIdx, attachment.system_attachment_id, attachment.system_attachment);
                })
            }

            if (reminder_date) {
                const usersReminder = commentTaskUsers?.map(c => { return { label: c.user?.name || '', value: c.user_id } }) || [];
                if (!usersReminder.find(u => u.value === user?.id)) {
                    usersReminder.push({ label: user?.name || '', value: user?.id || 0 });
                }
                //"Lembrete adicionado automaticamente pelo usuário XXXXXX durante comentário do dia xx/xx/xxxx as xx:xx"
                let commentReminder = `Lembrete adicionado automaticamente pelo usuário ${user?.name} durante comentário do dia ${moment().format('DD/MM/YYYY [as] HH:mm')}`;
                await submitReminderDialog(setFieldValue, comments, commentReminder, reminder_date, usersReminder);
            }
        }
        setCommentDialogOpen(false);
    }

    function setChanges(changed: boolean) {
        setDirty(changed);
        if (onChange) onChange(changed);
    }

    function moveAttachmentFromAnalysisToSolution(idx: number, attachments: AttachmentTaskRow[], setFieldValue: any) {
        attachments[idx].type = AttachmentTaskType.Solution;
        attachments[idx].edited = true;
        setFieldValue('attachments', attachments);
    }

    var extraWhereUserId: WhereCondition<User> = [];
    extraWhereUserId.push(['active', '=', true]);
    extraWhereUserId.push(['type', '=', UserType.Commbox]);
    extraWhereUserId.push(['perm_task', '=', true]);

    var extraWhereTicketStatusId: WhereCondition<User> = [];
    if (!isInternal) {
        extraWhereTicketStatusId.push(['use_in_task', '=', true]);
    } else {
        extraWhereTicketStatusId.push(['use_in_task_internal', '=', true]);
    }
    if (rulesByTicketType.ticket_status_ids.length > 0) {
        extraWhereTicketStatusId.push(['id', 'in', rulesByTicketType.ticket_status_ids]);
    }
    extraWhereTicketStatusId.push(['departments.id', 'in', userDepartmentIds]);

    if (allow_edit_task_resolution === false) {
        extraWhereTicketStatusId.push(['closed', '=', false]);
    }

    function disableOptionsTicketStatus(ticketStatus: TicketStatus): boolean {
        if (ticketStatus.closed === true && allow_edit_task_resolution === false) {
            return true;
        }
        return false;
    }

    async function loadRulesByTicketType(ticket_type_id?: number | null, setFieldValue?: any, values?: TaskFormData) {
        let approvers: User[] = [];
        let setDefaults = true;
        if (ticket_type_id) {
            const ticketType = await apiTicketType.getById(ticket_type_id, { relations: ['ticket_layout_type', 'ticket_layout_type.tickets_status', 'departments', 'user_approval_emails'] });
            approvers = ticketType?.user_approval_emails || [];
            if (ticketType && ticketType.ticket_layout_type) {
                setDefaults = false;
                setRulesByTicketType({
                    ticket_status_ids: ticketType.ticket_layout_type?.tickets_status?.map(ts => ts.id) || [],
                    rule_tag: ticketType.ticket_layout_type.rule_tag || TicketLayoutTypeRule.Optional,
                    rule_final_customer: ticketType.ticket_layout_type.rule_final_customer || TicketLayoutTypeRule.Optional,
                    rule_require_attachment_development: ticketType.ticket_layout_type.rule_require_attachment_development || TicketLayoutTypeRule.Optional,
                    rule_origin: ticketType.ticket_layout_type.rule_origin || TicketLayoutTypeRule.Optional,
                    rule_client_contacts: ticketType.ticket_layout_type.rule_client_contacts || TicketLayoutTypeRule.Optional,
                    rule_post_service_tab: ticketType.ticket_layout_type.rule_post_service_tab || TicketLayoutTypeRule.Optional,
                    rule_effort_estimate: ticketType.ticket_layout_type.rule_effort_estimate || TicketLayoutTypeRule.Optional,
                    rule_delivery_forecast: ticketType.ticket_layout_type.rule_delivery_forecast || TicketLayoutTypeRule.Optional,
                    rule_quantity_to_be_produced: ticketType.ticket_layout_type.rule_quantity_to_be_produced || TicketLayoutTypeRule.Optional,
                    rule_last_status_update: ticketType.ticket_layout_type.rule_last_status_update || TicketLayoutTypeRule.Optional,
                    rule_attachment_client: ticketType.ticket_layout_type.rule_attachment_client || TicketLayoutTypeRule.Optional,
                    rule_attachment_analysis: ticketType.ticket_layout_type.rule_attachment_analysis || TicketLayoutTypeRule.Optional,
                    rule_attachment_solution: ticketType.ticket_layout_type.rule_attachment_solution || TicketLayoutTypeRule.Optional,
                    rule_checklist: ticketType.ticket_layout_type.rule_checklist || TicketLayoutTypeRule.Optional,
                    rule_comment_attachment: ticketType.ticket_layout_type.rule_comment_attachment || TicketLayoutTypeRule.Optional,
                    rule_comment_reminder: ticketType.ticket_layout_type.rule_comment_reminder || TicketLayoutTypeRule.Optional,
                    loaded: true,
                    ticket_type_id: ticket_type_id
                });
                if (setFieldValue && values) {
                    if (ticketType.ticket_layout_type.tickets_status && ticketType.ticket_layout_type.tickets_status.length > 0 && !ticketType.ticket_layout_type.tickets_status.some(ts => ts.id === values.ticket_status_id)) {
                        await setFieldValue('ticket_status_id', null);
                    }
                    if (ticketType.ticket_layout_type.rule_tag === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('tags', []);
                    }
                    if (ticketType.ticket_layout_type.rule_final_customer === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('final_customer_id', commboxId || null);
                    } else {
                        if (isInternal) {
                            await setFieldValue('final_customer_id', commboxId ?? null);
                        }
                    }
                    if (ticketType.ticket_layout_type.rule_require_attachment_development === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('required_dev_attach', false);
                    }
                    if (ticketType.ticket_layout_type.rule_origin === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('ticket_origin_id', null);
                    }
                    if (ticketType.ticket_layout_type.rule_client_contacts === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('customer_contacts', []);
                    }
                    if (ticketType.ticket_layout_type.rule_effort_estimate === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('effort_estimation', '');
                    }
                    if (ticketType.ticket_layout_type.rule_delivery_forecast === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('delivery_forecast', null);
                    }
                    if (ticketType.ticket_layout_type.rule_quantity_to_be_produced === TicketLayoutTypeRule.NotVisible) {
                        await setFieldValue('prod_amount_to_be_produced', null);
                    }
                    if (ticketType.ticket_layout_type?.default_priority && !values.priority) {
                        await setFieldValue('priority', ticketType.ticket_layout_type.default_priority);
                    }

                    if (ticketType.ticket_layout_type.rule_comment_reminder === TicketLayoutTypeRule.NotVisible) {
                        setTaskReminders([]);
                    }
                }
            }
        }
        setTicketTypeApprovers(approvers);
        if (setDefaults) {
            setRulesByTicketType({
                ticket_status_ids: [],
                rule_tag: TicketLayoutTypeRule.Optional,
                rule_final_customer: TicketLayoutTypeRule.Optional,
                rule_require_attachment_development: TicketLayoutTypeRule.Optional,
                rule_origin: TicketLayoutTypeRule.Optional,
                rule_client_contacts: TicketLayoutTypeRule.Optional,
                rule_post_service_tab: TicketLayoutTypeRule.Optional,
                rule_effort_estimate: TicketLayoutTypeRule.Optional,
                rule_delivery_forecast: TicketLayoutTypeRule.Optional,
                rule_quantity_to_be_produced: TicketLayoutTypeRule.Optional,
                rule_last_status_update: TicketLayoutTypeRule.Optional,
                rule_attachment_client: TicketLayoutTypeRule.Optional,
                rule_attachment_analysis: TicketLayoutTypeRule.Optional,
                rule_attachment_solution: TicketLayoutTypeRule.Optional,
                rule_checklist: TicketLayoutTypeRule.Optional,
                rule_comment_attachment: TicketLayoutTypeRule.Optional,
                rule_comment_reminder: TicketLayoutTypeRule.Optional,
                loaded: true,
                ticket_type_id: ticket_type_id || null
            });
        }
    }

    async function setRulesByStatus(ticket_status_id?: number | null, first?: boolean) {
        let isMandatory = false;
        let isScheduled = false;
        let disableComment = false;
        if (ticket_status_id) {
            const ticketStatus = await apiTicketStatus.getById(ticket_status_id);
            isMandatory = ticketStatus.closed;
            isScheduled = ticketStatus.is_scheduled;
            disableComment = ticketStatus.disable_comment;
        }
        if (!!first) {
            setIsActualTicketStatusClosed(isMandatory);
        }
        setIsFieldsMandatoryByTicketStatus(isMandatory);
        setIsScheduled(isScheduled);
        setIsDisableComment(disableComment);
    }

    async function scheduleGoogle(values: TaskFormData) {
        //http://www.google.com/calendar/event?action=TEMPLATE&trp=false&dates=20230324T090000/20230324T090000
        var urlGoogle = 'http://www.google.com/calendar/event?action=TEMPLATE&trp=false';
        urlGoogle += `&text=${encodeURIComponent(values.name)}`;
        urlGoogle += `&details=${encodeURIComponent(values.description)}`;
        urlGoogle += `&add=${encodeURIComponent(user?.email || '')}`;
        await Promise.all(values.customer_contacts.map(async (i) => {
            const userContact = await apiUser.getById(i);
            if (userContact) {
                urlGoogle += `&add=${encodeURIComponent(userContact.email)}`;
            }
        }));
        let scheduledDataFormatted = moment(values.scheduled_date).format('YYYYMMDD[T]HHmmss');
        urlGoogle += `&dates=${scheduledDataFormatted}/${scheduledDataFormatted}`;
        window.open(urlGoogle, "_blank");
    }

    async function onAddTag(t: ReactTagsData, tags: ReactTagsData[], setFieldValue: any) {
        const tag = t;
        const searchTag = await apiTag.getList({ where: [['name', '=', t.text], ['type', '=', TagType.Task]] });
        if (searchTag.length > 0) {
            tag.id = String(searchTag[0].id);
            tag.text = searchTag[0].name;
        } else {
            const newTag = await apiTag.insert({ name: t.text, type: TagType.Task });
            tag.id = String(newTag.id);
            setTagSuggestions([...tagSuggestions, tag]);
        }
        await setFieldValue('tags', [...tags, tag]);
    }

    async function addChecklist(checklists: TaskChecklistRow[], setFieldValue: any, checklist_id: number, is_mandatory: boolean) {
        const checklist = await apiChecklist.getById(checklist_id, { relations: ['checklist_items'] });
        checklists.push({ id: 0, checklist_id: checklist_id, task_checklist_items: [], is_mandatory: is_mandatory, task_id: 0, checklist: checklist, not_filled: false, not_filled_at: null, not_filled_user_id: null });
        await setFieldValue('checklists', checklists);
        closeAddChecklistDialog();
    }

    async function addReference(references: Task[], setFieldValue: any, reference_id: number) {
        const reference = await api.getById(reference_id);
        references.push(reference);
        await setFieldValue('references', references);
        closeAddReferenceDialog();
    }

    function removeChecklist(idx: number, checklists: TaskChecklistRow[], setFieldValue: any) {
        let checklist = checklists.find((o, i) => i === idx);
        setFieldValue('checklists', checklists.filter((o, i) => i !== idx));
        if (checklist && checklist.id > 0) {
            checklistsRemoved.push(checklist);
            setChecklistsRemoved(checklistsRemoved);
        }
    }

    function removeReference(id: number, references: Task[], setFieldValue: any) {
        setFieldValue('references', references.filter((o) => o.id !== id));
    }

    function openAddChecklistDialog() {
        setAddChecklistDialogOpen(true);
    }

    function openAddReferenceDialog() {
        setAddReferenceDialogOpen(true);
    }

    function closeAddChecklistDialog() {
        setAddChecklistDialogOpen(false);
    }

    function closeAddReferenceDialog() {
        setAddReferenceDialogOpen(false);
    }

    function openProjectCreateDialog(taskValues: TaskFormData) {
        if (!(isInternal && user?.admin_type === UserAdminType.SuperAdmin)) {
            return;
        }
        const availableObserverIds = observers.map(option => option.value);
        const uniqueObservers = Array.from(new Set((taskValues.observers || []).filter(id => availableObserverIds.includes(id))));
        if (user?.id && availableObserverIds.includes(user.id) && !uniqueObservers.includes(user.id)) {
            uniqueObservers.push(user.id);
        }
        setProjectCreateInitialValues({
            name: '',
            ticket_status_id: null,
            user_id: taskValues.user_id || null,
            product_line_id: null,
            observers: uniqueObservers,
            description: '',
            description_report: ''
        });
        setProjectCreateDialogOpen(true);
    }

    async function submitProjectCreateDialog(data: ProjectQuickCreateFormData, setFieldValue: any) {
        try {
            setIsSavingProject(true);
            setLoading(true);
            const payload = {
                name: data.name,
                vip: false,
                description: data.description,
                description_report: data.description_report,
                user_id: data.user_id,
                ticket_status_id: data.ticket_status_id,
                product_line_id: data.product_line_id,
                observers: data.observers,
                created_by_user_id: user?.id || null,
                short_name: '',
                use_in_task: !isInternal,
                use_in_task_internal: isInternal
            };
            const result = await apiProject.insert(payload);
            if (!result) {
                throw new Error('Erro ao cadastrar projeto');
            }
            enqueueSnackbar('Projeto cadastrado com sucesso!', { variant: 'success' });
            await setFieldValue('project_id', result.id);
            if (data.observers?.length) {
                const uniqueObserverIds = Array.from(new Set(data.observers));
                await setFieldValue('observers', uniqueObserverIds);
            }
            setLastUsedProjects(result.id, result.name || data.name);
            setProjectSearchKey(prev => prev + 1);
            setProjectCreateDialogOpen(false);
        } catch (error) {
            if (error instanceof Error) {
                enqueueSnackbar(error.message, { variant: 'error' });
            }
        } finally {
            setIsSavingProject(false);
            setLoading(false);
        }
    }

    async function checkUncheckTaskChecklistItem(checked: boolean, task_checklist_id: number, checklist_item_id: number, task_checklist_item_id?: number) {
        const checkTaskUpdatedAt = await validateTaskUpdatedAt();
        if (checkTaskUpdatedAt) {
            let checklist = taskChecklists.find((c) => c.id === task_checklist_id);
            if (checklist && user && checklist.task_checklist_items) {
                if (checked) {
                    const taskChecklistItemListTemp = await apiTaskChecklistItem.getList({ where: [['checklist_item_id', '=', checklist_item_id], ['task_checklist_id', '=', task_checklist_id]] });
                    if (taskChecklistItemListTemp.length > 0) {
                        while (taskChecklistItemListTemp.length > 0) {
                            await apiTaskChecklistItem.delete(taskChecklistItemListTemp[0].id);
                            taskChecklistItemListTemp.shift();
                        }
                    }
                    const taskChecklistItem = await apiTaskChecklistItem.insert({ user_id: user.id, checklist_item_id: checklist_item_id, task_checklist_id: task_checklist_id });
                    taskChecklistItem.user = user;
                    checklist.task_checklist_items.push(taskChecklistItem);
                } else if (task_checklist_item_id) {
                    await apiTaskChecklistItem.delete(task_checklist_item_id);
                    checklist.task_checklist_items = checklist.task_checklist_items.filter((c) => c.id !== task_checklist_item_id);
                }
                setTaskChecklists([...taskChecklists]);
            }
        }
    }

    async function setTaskChecklistIsMandatory(idx: number, taskChecklistId: number, is_mandatory: boolean, checklists: TaskChecklistRow[], setFieldValue: any) {
        const checkTaskUpdatedAt = await validateTaskUpdatedAt();
        if (checkTaskUpdatedAt) {
            if (taskChecklistId !== 0) {
                let checklist = taskChecklists.find((c) => c.id === taskChecklistId);
                if (checklist) {
                    await api.updateChecklistIsMandatory(taskChecklistId, is_mandatory);
                    checklist.is_mandatory = is_mandatory;
                    setTaskChecklists([...taskChecklists]);
                }
            } else {
                setFieldValue('checklists', checklists.map((c, i) => {
                    if (i === idx) c.is_mandatory = is_mandatory;
                    return c
                }));
            }
        }
    }

    async function setTaskChecklistNotFilled(taskChecklistId: number, not_filled: boolean, checklists: TaskChecklistRow[], setFieldValue: any) {
        const checkTaskUpdatedAt = await validateTaskUpdatedAt();
        if (checkTaskUpdatedAt) {
            let checklist = taskChecklists.find((c) => c.id === taskChecklistId);
            if (checklist && user) {
                await api.checklistNotFilled(taskChecklistId, user.id, not_filled);
                checklist.not_filled = not_filled;
                checklist.not_filled_user = user;
                checklist.not_filled_at = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
                setTaskChecklists([...taskChecklists]);
            }
        }
    }

    const lastUsedTags = getLastUsedTags();
    const lastUsedProjects = getLastUsedProjects();

    if (!rulesByTicketType.loaded) return null;

    return (
        <Panel
            panelHeaderTitle={title}
            panelFooterButtons={<FormFooterAllButtons onUndo={onUndo} form="task_form" onBack={onCancel} isDirty={isDirty} enableSaveAndCreateNew={allow_edit_task_gen_att_cli} />}
        >
            <PanelBodyFormContent style={{ overflow: 'auto' }}>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Form<TaskFormData>
                            ref={formRef}
                            initialValues={initialValues}
                            validationSchema={getValidationSchema()}
                            onSubmit={(a, b, c, d) => onSubmitHandler(a, b, c, d)}
                            onChange={setChanges}
                            style={{ overflow: 'auto' }}
                            id="task_form"
                            enableReinitialize
                        >
                            {({ isSubmitting, values, errors, handleChange, dirty, setFieldValue, handleChangeNumber }) => {
                                const handleCloseConfirmationCancel = () => {
                                    resetCloseConfirmationState();
                                };

                                const handleCloseConfirmationConfirm = async (dialogValues: TaskCloseConfirmationResult) => {
                                    if (!!dialogValues.feedback_to_improve_item && !dialogValues.feedback_to_improve_text) {
                                        enqueueSnackbar('Por favor, preencha o campo de texto para enviar o feedback.', { variant: 'error' });
                                        return;
                                    }

                                    const context = closeConfirmationContext;
                                    resetCloseConfirmationState();
                                    if (!context) {
                                        return;
                                    }

                                    if (dialogValues.ticket_type_id !== values.ticket_type_id) {
                                        await handleTicketTypeChange(dialogValues.ticket_type_id, values, setFieldValue);
                                    }

                                    if (dialogValues.project_id !== values.project_id) {
                                        await setFieldValue('project_id', dialogValues.project_id);
                                    }

                                    await setFieldValue('feedback_to_improve_item', dialogValues.feedback_to_improve_item);
                                    await setFieldValue('feedback_to_improve_text', dialogValues.feedback_to_improve_text);

                                    if (!!dialogValues.feedback_to_improve_item && (values.feedback_to_improve_item !== dialogValues.feedback_to_improve_item || values.feedback_to_improve_text !== dialogValues.feedback_to_improve_text)) {
                                        const lanzaBotList = await apiUser.getList({ where: [['name', '=', 'LanzaBot']] });
                                        let comment = `Feedback para melhoria do sistema recebido\n`;
                                        comment += `Item para melhoria: \n${dialogValues.feedback_to_improve_item === FeedbackImproveItem.Hardware ? 'Hardware' : dialogValues.feedback_to_improve_item === FeedbackImproveItem.Documentation ? 'Documentação' : 'Software'}\n\n`;
                                        comment += `Texto do feedback: \n${dialogValues.feedback_to_improve_text}\n\n`;
                                        await submitCommentDialog(setFieldValue, values.comments, comment, false, undefined, [dialogValues.feedback_to_improve_item === FeedbackImproveItem.Software ? FixedIds.idPedro : FixedIds.idMarcio], undefined, undefined, lanzaBotList[0]);
                                    }

                                    const latestValues = formRef.current?.getValues() || values;
                                    const latestDirty = (formRef.current as any)?.state?.dirty || dirty;

                                    await onSubmitHandler(latestValues, latestDirty, undefined, context.submitType, context.proceedCommentStatus,
                                        context.proceedAddTag, context.proceedStatusLimit, true);
                                };

                                const handleIaSuggestionsReload = async () => {
                                    const currentValues = formRef.current?.getValues() || values;
                                    const commentsText = currentValues.comments?.map((comment: CommentTask) => comment.comment).filter((comment) => !!comment).join('\n') || null;
                                    await requestIaSuggestions(currentValues.description || null, currentValues.solution || null, commentsText);
                                };

                                return (
                                    <>
                                        {rulesByTicketType.rule_tag !== TicketLayoutTypeRule.NotVisible && values.ticket_type_id ? <>
                                            <ReactTags
                                                tags={values.tags}
                                                suggestions={tagSuggestions}
                                                delimiters={delimiters}
                                                handleDelete={(i) => {
                                                    setFieldValue('tags', values.tags.filter((tag, index) => index !== i));
                                                }}
                                                handleAddition={async (t) => {
                                                    if (t.text.length > 2) {
                                                        await onAddTag(t, values.tags, setFieldValue);
                                                    } else {
                                                        enqueueSnackbar('Mínimo de 3 caracteres para adicionar uma TAG.', { variant: 'error' });
                                                    }
                                                }}
                                                handleTagClick={(index) => {
                                                    console.log('The tag at index ' + index + ' was clicked');
                                                }}
                                                allowDragDrop={false}
                                                placeholder="Adicionar tag"
                                                classNames={{
                                                    tagInputField: theme.palette.mode === 'dark' ? 'ReactTags__tagInputFieldDark' : 'ReactTags__tagInputField'
                                                }}
                                                allowAdditionFromPaste={false}
                                                minQueryLength={1}
                                                allowDeleteFromEmptyInput={false}
                                            />
                                            {lastUsedTags.length > 0 ?
                                                <Box marginTop={1}>
                                                    <Box display="flex" flexWrap="wrap" alignItems={'center'}>
                                                        <Typography variant='subtitle2'>Últimas tags utilizadas:</Typography>
                                                        {lastUsedTags.map((tag, idx) => {
                                                            return (
                                                                <Chip
                                                                    key={idx}
                                                                    label={tag.text}
                                                                    style={{ margin: 2 }}
                                                                    onClick={() => {
                                                                        if (!values.tags.find(t => t.text === tag.text)) {
                                                                            onAddTag(tag, values.tags, setFieldValue)
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        })}
                                                    </Box>
                                                </Box> : null}
                                        </> : null}
                                        <Box marginTop={3} marginBottom={0} display="flex" >
                                            <Typography style={{ flex: 1 }} variant='subtitle2' className="subtitleGradientBackgorund">Chamado</Typography>
                                            {item?.id ? <Tooltip placement="top" title={'Download PDF'}>
                                                <IconButton
                                                    size='small'
                                                    color="inherit"
                                                    aria-label={'Download PDF'}
                                                    onClick={() => downloadPdf(item.id, item.ticket_code)}
                                                >
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            </Tooltip> : null}
                                        </Box>
                                        <Divider style={{ marginBottom: 4 }} />
                                        {values.ticket_type_id ? <Grid container alignItems="center" spacing={1}>
                                            {item?.ticket_code ?
                                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <TextField
                                                        name="ticket_code"
                                                        label='Código'
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                        value={item.ticket_code}
                                                        style={{ flex: 1 }}
                                                    />
                                                    <Tooltip placement="top" title={'Copiar "código - assunto" para usar no commit'}>
                                                        <IconButton
                                                            size='small'
                                                            color="inherit"
                                                            aria-label={'Copiar código e assunto'}
                                                            onClick={async () => {
                                                                try {
                                                                    const code = item?.ticket_code || '';
                                                                    const subject = values.name || '';
                                                                    const text = `${code} - ${subject}`;
                                                                    if (navigator?.clipboard?.writeText) {
                                                                        await navigator.clipboard.writeText(text);
                                                                    } else {
                                                                        const ta = document.createElement('textarea');
                                                                        ta.value = text;
                                                                        ta.style.position = 'fixed';
                                                                        ta.style.opacity = '0';
                                                                        document.body.appendChild(ta);
                                                                        ta.focus();
                                                                        ta.select();
                                                                        document.execCommand('copy');
                                                                        document.body.removeChild(ta);
                                                                    }
                                                                    enqueueSnackbar('Copiado para a área de transferência.', { variant: 'info' });
                                                                } catch (err) {
                                                                    enqueueSnackbar('Não foi possível copiar.', { variant: 'error' });
                                                                }
                                                            }}
                                                        >
                                                            <img src={gitlabLogo} alt="Git" style={{ width: 22, height: 22 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                                : null}
                                            <Grid item xs={12} sm={12} md={12} lg={item?.ticket_code ? 5 : 9} xl={item?.ticket_code ? 5 : 9}>
                                                <TextField
                                                    name="name"
                                                    label='Assunto'
                                                    margin="dense"
                                                    variant="outlined"
                                                    required
                                                    fullWidth
                                                    disabled={!allow_edit_task_gen_att_cli}
                                                    autoFocus={true}
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    error={!!errors.name && !!dirty.name}
                                                    helperText={!!errors.name && !!dirty.name && errors.name}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                {item?.created_by_user ?
                                                    <TextField
                                                        name="created_by_user"
                                                        label='Criado por'
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled
                                                        value={item.created_by_user.name}
                                                    />
                                                    : null}
                                            </Grid>
                                        </Grid> : null}
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                <SearchEntity<TicketType, 'id', 'name'>
                                                    name="ticket_type_id"
                                                    entity="ticketType"
                                                    valueField='id'
                                                    labelField="name"
                                                    label="Tipo"
                                                    value={values.ticket_type_id || null}
                                                    onChangeHandle={async (_, v) => await handleTicketTypeChange(v, values, setFieldValue)}
                                                    required
                                                    extraWhere={[[(!isInternal ? 'use_in_task' : 'use_in_task_internal'), '=', true]]}
                                                    isDisabled={!allow_edit_task_gen_att_cli || item?.ticket_type_id === FixedIds.ticketTypeFalhaHardware}
                                                />
                                            </Grid>
                                            {values.ticket_type_id ? <>
                                                {rulesByTicketType.rule_final_customer !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <SearchEntity<FinalCustomer, 'id', 'name'>
                                                        name="final_customer_id"
                                                        entity="finalCustomer"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Cliente final"
                                                        value={values.final_customer_id || null}
                                                        style={{ flex: 1 }}
                                                        onChangeHandle={async (_, v) => {
                                                            await setFieldValue('final_customer_id', v);
                                                            await setFieldValue('customer_contacts', []);
                                                            await setFieldValue('products_s', []);
                                                            await setFieldValue('products_h', []);
                                                            await setFieldValue('technical_assistances', []);
                                                            await fetchDataByFinalCustomer(v, false, setFieldValue);
                                                        }}
                                                        required={rulesByTicketType.rule_final_customer === TicketLayoutTypeRule.Required}
                                                        //isDisabled={!allow_edit_task_gen_att_cli || !!finalCustomerId || item?.final_customer_id === commboxId}
                                                        isDisabled={!!item?.id}
                                                        extraWhere={[['id', (isInternal ? '=' : '!='), commboxId]]}
                                                    />
                                                    {!isInternal && <Tooltip placement="top" title={getContractStatusTooltip()}>
                                                        <span>
                                                            <IconButton
                                                                size='small'
                                                                aria-label={getContractStatusTooltip()}
                                                                onClick={() => setFinalCustomerContractsDialogOpen(true)}
                                                                disabled={!values.final_customer_id || finalCustomerContractsStatus === 'loading'}
                                                                sx={{ color: values.final_customer_id ? getContractStatusColor() : 'inherit' }}
                                                            >
                                                                {finalCustomerContractsStatus === 'loading' ? (
                                                                    <CircularProgress size={20} />
                                                                ) : (
                                                                    <ArticleIcon />
                                                                )}
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>}
                                                    <Tooltip placement="top" title={'Abrir em nova guia cadastro de cliente final'}>
                                                        <IconButton
                                                            size='small'
                                                            color="inherit"
                                                            aria-label={'Abrir em nova guia cadastro de cliente final'}
                                                            onClick={() => {
                                                                if (values.final_customer_id) {
                                                                    window.open(`#/system/administration/finalCustomers/${values.final_customer_id}`);
                                                                } else {
                                                                    window.open(`#/system/administration/finalCustomers/add`);
                                                                }
                                                            }}
                                                        >
                                                            <OpenInNewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={!finalCustomerTaskObservation ? 'Não há observações de chamado deste cliente final' : 'Observações de chamado do cliente final'}>
                                                        <span>
                                                            <IconButton
                                                                size='small'
                                                                color="inherit"
                                                                aria-label={!finalCustomerTaskObservation ? 'Não há observações de chamado deste cliente final' : 'Observações de chamado do cliente final'}
                                                                onClick={() => setFinalCustomerTaskObservationDialogOpen(true)}
                                                                disabled={!finalCustomerTaskObservation}
                                                            >
                                                                <InfoIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={'Abrir em nova guia cadastro de integrador'}>
                                                        <IconButton
                                                            size='small'
                                                            color="inherit"
                                                            aria-label={'Abrir em nova guia cadastro de integrador'}
                                                            onClick={() => {
                                                                if (integratorId) {
                                                                    window.open(`#/system/administration/integrators/${integratorId}`, "_blank");
                                                                } else {
                                                                    window.open(`#/system/administration/integrators/add`);
                                                                }
                                                            }}
                                                        >
                                                            <OpenInNewIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={!integratorTaskObservation ? 'Não há observações de chamado deste integrador' : 'Observações de chamado do integrador'}>
                                                        <span>
                                                            <IconButton
                                                                size='small'
                                                                color="inherit"
                                                                aria-label={!integratorTaskObservation ? 'Não há observações de chamado deste integrador' : 'Observações de chamado do integrador'}
                                                                onClick={() => setIntegratorTaskObservationDialogOpen(true)}
                                                                disabled={!integratorTaskObservation}
                                                            >
                                                                <InfoIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>}
                                                {rulesByTicketType.rule_origin !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                    <SearchEntity<TicketOrigin, 'id', 'name'>
                                                        name="ticket_origin_id"
                                                        entity="ticketOrigin"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Origem"
                                                        value={values.ticket_origin_id || null}
                                                        onChangeHandle={(_, v) => setFieldValue('ticket_origin_id', v)}
                                                        isClearable
                                                        extraWhere={[['use_in_task', '=', true]]}
                                                        isDisabled={!allow_edit_task_gen_att_cli}
                                                        required={rulesByTicketType.rule_origin === TicketLayoutTypeRule.Required}
                                                    />
                                                </Grid>}
                                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                    <SearchEntity<TicketStatus, 'id', 'name'>
                                                        name="ticket_status_id"
                                                        entity="ticketStatus"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Status"
                                                        value={values.ticket_status_id || null}
                                                        onChangeHandle={async (_, v) => {
                                                            await setFieldValue('ticket_status_id', v);
                                                            await setFieldValue('scheduled_date', null);
                                                            await setRulesByStatus(v);
                                                        }}
                                                        required
                                                        disableOptions={disableOptionsTicketStatus}
                                                        extraWhere={extraWhereTicketStatusId}
                                                        key={`ticket_status_${values.ticket_type_id || 0}`}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                    <SearchEntity<User, 'id', 'name'>
                                                        name="user_id"
                                                        entity="user"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Atribuído para"
                                                        customLabel={(i) => {
                                                            return getUserWithVacationName(i);
                                                        }}
                                                        value={values.user_id}
                                                        onChangeHandle={async (_, v) => {
                                                            await setFieldValue('user_id', v);
                                                            if (v) {
                                                                const userSelected = await apiUser.getById(v, { relations: ['current_or_next_vacation', 'department', 'departments'] });
                                                                if (userSelected) {
                                                                    fillRelatedUsers(userSelected);
                                                                }
                                                            } else {
                                                                fillRelatedUsers();
                                                            }
                                                        }}
                                                        required
                                                        //isDisabled={!allow_edit_task_gen_att_cli}
                                                        extraWhere={extraWhereUserId}
                                                        filterResults={(us) => {
                                                            return us.filter((u) => {
                                                                let permsByDp = getUserDepartmentPermissions(u);
                                                                return !!permsByDp.perm_menu_tasks || isInternal;
                                                            });
                                                        }}
                                                        relations={['current_or_next_vacation', 'department', 'departments']}
                                                        normalizeSearch
                                                    />
                                                </Grid>
                                                {(user?.admin_type === UserAdminType.SuperAdmin || !isInternal) ? <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                                    <Box display="flex" alignItems="center">
                                                        <SearchEntity<Project, 'id', 'name'>
                                                            name="project_id"
                                                            entity="project"
                                                            valueField='id'
                                                            labelField="name"
                                                            label="Projeto"
                                                            value={values.project_id}
                                                            required
                                                            onChangeHandle={async (name, v) => {
                                                                await setFieldValue('project_id', v);
                                                            }}
                                                            extraWhere={[['ticket_status.closed', '=', false], ['use_in_task' + (isInternal ? '_internal' : ''), '=', true]]}
                                                            useOldWhereApi
                                                            key={`project-search-${projectSearchKey}`}
                                                            style={{ flex: 1 }}
                                                        />
                                                        {isInternal && user?.admin_type === UserAdminType.SuperAdmin ? (
                                                            <Tooltip placement="top" title={'Cadastrar projeto'}>
                                                                <span>
                                                                    <IconButton
                                                                        size='small'
                                                                        color="inherit"
                                                                        aria-label={'Cadastrar projeto'}
                                                                        onClick={() => openProjectCreateDialog(values)}
                                                                        disabled={isSavingProject}
                                                                        style={{ marginLeft: 4 }}
                                                                    >
                                                                        <AddIcon fontSize="small" />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        ) : null}
                                                    </Box>
                                                </Grid> : null}
                                                {!isInternal && <>
                                                    <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <MultiSelect<number>
                                                            name='products_s'
                                                            label={'Softwares'}
                                                            onChange={(com) => setFieldValue('products_s', com)}
                                                            options={productsS}
                                                            values={values.products_s}
                                                            disabled={values.final_customer_id === null || !allow_edit_task_gen_att_cli}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <MultiSelect<number>
                                                            name='products_h'
                                                            label={'Hardwares'}
                                                            onChange={(com) => setFieldValue('products_h', com)}
                                                            options={productsH}
                                                            values={values.products_h}
                                                            disabled={values.final_customer_id === null || !allow_edit_task_gen_att_cli}
                                                        />
                                                    </Grid>
                                                </>}
                                            </> : null}
                                        </Grid>
                                        {values.ticket_type_id ? <>
                                            {!item?.id && lastUsedProjects.length > 0 ? <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <Box display="flex" flexWrap="wrap" alignItems={'center'}>
                                                        <Typography variant='subtitle2'>Últimos projetos utilizados:</Typography>
                                                        {lastUsedProjects.map((project, idx) => {
                                                            return (
                                                                <Chip
                                                                    key={idx}
                                                                    label={project.label}
                                                                    style={{ margin: 2 }}
                                                                    onClick={() => {
                                                                        if (!values.project_id) {
                                                                            setFieldValue('project_id', project.value);
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        })}
                                                    </Box>
                                                </Grid>
                                            </Grid> : null}
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <MultiSelect<number>
                                                        name='observers'
                                                        label={'Observadores'}
                                                        onChange={(com) => setFieldValue('observers', com)}
                                                        options={observers}
                                                        values={values.observers}
                                                        helperText={user && !values.observers.includes(user.id) ? <span onClick={() => { setFieldValue('observers', [...values.observers, user.id]) }} style={{ cursor: 'pointer' }}>Você não é um observador, deseja se tornar um?</span> : undefined}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container alignItems="center" spacing={1}>
                                                {rulesByTicketType.rule_client_contacts !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                                    <MultiSelect<number>
                                                        name='customer_contacts'
                                                        label={'Contatos do Cliente e/ou do Integrador'}
                                                        onChange={(com) => setFieldValue('customer_contacts', com)}
                                                        options={customerContacts}
                                                        values={values.customer_contacts}
                                                        disabled={values.final_customer_id === null || !allow_edit_task_gen_att_cli}
                                                        required={rulesByTicketType.rule_client_contacts === TicketLayoutTypeRule.Required || values.technical_assistances.length > 0}
                                                    />
                                                </Grid>}
                                                {rulesByTicketType.rule_last_status_update !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                                                    <TextField
                                                        name="last_update_status"
                                                        label='Última atualização status'
                                                        margin="dense"
                                                        variant="outlined"
                                                        disabled
                                                        value={item?.last_update_status ? moment(item.last_update_status).format('DD/MM/YYYY HH:mm:ss') : ''}
                                                        fullWidth
                                                    />
                                                </Grid>}
                                                {item ? <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                                                    <ServiceTimeCounter
                                                        service_time={item.service_time}
                                                        service_time_start={item.service_time_start}
                                                        service_time_end={item.service_time_end}
                                                        returnInput
                                                    />
                                                </Grid> : undefined}
                                                {isInternal ? <>
                                                    {rulesByTicketType.rule_require_attachment_development !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <SelectSearch<boolean>
                                                            name='required_dev_attach'
                                                            label='Exigência de anexo de desenvolvimento'
                                                            options={[
                                                                { label: 'Sim', value: true },
                                                                { label: 'Não', value: false },
                                                            ]}
                                                            value={values.required_dev_attach}
                                                            onChangeHandle={(_, v) => {
                                                                setFieldValue('required_dev_attach', v || false)
                                                            }}
                                                            margin='dense'
                                                            fullWidth
                                                            required
                                                            isDisabled={!allow_edit_task_resolution}
                                                        />
                                                    </Grid>}
                                                    <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <TextField
                                                            name="priority"
                                                            label={'Prioridade'}
                                                            margin="dense"
                                                            variant="outlined"
                                                            fullWidth
                                                            inputProps={{ maxLength: 3 }}
                                                            value={values.priority || ''}
                                                            onChange={e => {
                                                                const re = /^[0-9\b]+$/;
                                                                if (e.target.value === '' || re.test(e.target.value)) {
                                                                    handleChange(e);
                                                                }
                                                            }}
                                                            error={!!errors.priority && !!dirty.priority}
                                                            helperText={!!errors.priority && !!dirty.priority && errors.priority}
                                                        />
                                                    </Grid>
                                                    {rulesByTicketType.rule_effort_estimate !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <TextField
                                                            name="effort_estimation"
                                                            label='Estimativa de esforço'
                                                            margin="dense"
                                                            variant="outlined"
                                                            fullWidth
                                                            value={values.effort_estimation}
                                                            onChange={handleChange}
                                                            error={!!errors.effort_estimation && !!dirty.effort_estimation}
                                                            helperText={!!errors.effort_estimation && !!dirty.effort_estimation && errors.effort_estimation}
                                                            required={rulesByTicketType.rule_effort_estimate === TicketLayoutTypeRule.Required}
                                                        />
                                                    </Grid>}
                                                    {rulesByTicketType.rule_delivery_forecast !== TicketLayoutTypeRule.NotVisible && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                        <DatePicker
                                                            label={'Previsão de entrega'}
                                                            value={values.delivery_forecast}
                                                            onChange={(value) => setFieldValue('delivery_forecast', value)}
                                                            fullWidth
                                                            required={rulesByTicketType.rule_delivery_forecast === TicketLayoutTypeRule.Required}
                                                        />
                                                    </Grid>}
                                                    {rulesByTicketType.rule_quantity_to_be_produced !== TicketLayoutTypeRule.NotVisible && <>
                                                        <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                            <TextField
                                                                name="prod_amount_to_be_produced"
                                                                label={'Quantidade a ser produzida'}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                inputProps={{ maxLength: 6 }}
                                                                value={values.prod_amount_to_be_produced || ''}
                                                                onChange={e => {
                                                                    const re = /^[0-9\b]+$/;
                                                                    if (e.target.value === '' || re.test(e.target.value)) {
                                                                        handleChange(e);
                                                                    }
                                                                }}
                                                                error={!!errors.prod_amount_to_be_produced && !!dirty.prod_amount_to_be_produced}
                                                                helperText={!!errors.prod_amount_to_be_produced && !!dirty.prod_amount_to_be_produced && errors.prod_amount_to_be_produced}
                                                                required={rulesByTicketType.rule_quantity_to_be_produced === TicketLayoutTypeRule.Required}
                                                            />
                                                        </Grid>
                                                        {item && <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                                                            <TextField
                                                                name="prod_amount_to_be_produced"
                                                                label={'Quantidade produzida'}
                                                                margin="dense"
                                                                variant="outlined"
                                                                fullWidth
                                                                inputProps={{ maxLength: 6 }}
                                                                value={item?.prod_amount || '0'}
                                                                disabled
                                                            />
                                                        </Grid>}
                                                    </>}
                                                </>
                                                    : null}
                                                {isScheduled ? <Grid item xs={12} sm={12} md={12} lg={3} xl={3} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <DateTimePicker
                                                        label={'Data agendamento'}
                                                        value={values.scheduled_date}
                                                        onChange={(value) => setFieldValue('scheduled_date', value)}
                                                        style={{ flex: 1 }}
                                                    />
                                                    <Tooltip placement="top" title={'Marcar no Google Agenda'}>
                                                        <span>
                                                            <IconButton
                                                                size='small'
                                                                color="inherit"
                                                                aria-label={'Marcar no Google Agenda'}
                                                                onClick={() => scheduleGoogle(values)}
                                                                disabled={!values.scheduled_date}
                                                            >
                                                                <EventAvailableIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                    : null}
                                            </Grid>
                                            <Grid container alignItems="center" spacing={1} sx={{ marginTop: 1 }}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    {/* <TextField
                                                        name="description"
                                                        label={"Descrição"}
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        value={values.description}
                                                        onChange={handleChange}
                                                        error={!!errors.description && !!dirty.description}
                                                        helperText={!!errors.description && !!dirty.description && errors.description}
                                                        disabled={!allow_edit_task_gen_att_cli}
                                                        inputProps={{
                                                            style: {
                                                                resize: 'vertical', overflow: 'auto', height: heightDescription, minHeight: heightDescription, maxHeight: 999
                                                            }
                                                        }}
                                                    /> */}
                                                    <SafeDeskTextEditor
                                                        value={values.description}
                                                        onChange={(e) => {
                                                            setFieldValue('description', e.target.value)
                                                        }}
                                                        style={{ resize: 'vertical', overflow: 'auto', height: 250, minHeight: 100, maxHeight: 999 }}
                                                        disabled={!allow_edit_task_gen_att_cli}
                                                        placeholder='Descrição *'
                                                    />
                                                </Grid>
                                            </Grid>
                                            {!item?.id ? <TextTemplateButtons page={isInternal ? 'taskInternal' : 'task'} disabled={!!values.description} style={{ marginTop: 3 }} type={TextTemplateType.Description} onClick={(tt) => setFieldValue('description', tt.template)} /> : null}
                                            {(!isInternal && values.ticket_type_id === FixedIds.ticketTypeFalhaHardware) && <TechAssisTaskBox
                                                task={item}
                                                isDisabled={false}
                                                technicalAssistances={values.technical_assistances}
                                                onSubmit={async (data) => {
                                                    let technicalAssistances = values.technical_assistances || [];
                                                    const ticketStatus = data.ticket_status_id ? await apiTicketStatus.getById(data.ticket_status_id) : undefined;
                                                    const integrator = data.integrator_id ? await apiIntegrator.getById(data.integrator_id) : undefined;
                                                    const product = data.product_id ? await apiProduct.getById(data.product_id) : undefined;
                                                    const { seals } = data;
                                                    if (seals.length === 0) {
                                                        seals.push(data.seal);
                                                    }
                                                    for (var seal of seals) {
                                                        if (seal === '' && data.without_seal === false) continue;
                                                        technicalAssistances.push({
                                                            ticket_status_id: data.ticket_status_id,
                                                            final_customer_id: data.final_customer_id,
                                                            ticket_cause_id: data.ticket_cause_id,
                                                            integrator_id: data.integrator_id,
                                                            product_id: data.product_id,
                                                            equipment_return: data.equipment_return,
                                                            technical_assistance_id: data.technical_assistance_id,
                                                            without_invoice: data.without_invoice,
                                                            invoice_number: data.invoice_number,
                                                            observation_invoice: data.observation_invoice,
                                                            without_seal: data.without_seal,
                                                            seal: seal,
                                                            user_id: data.user_id,
                                                            charge_id: data.charge_id,
                                                            ticket_origin_id: data.ticket_origin_id,
                                                            firmware_updated: data.firmware_updated,
                                                            factory_reset: data.factory_reset,
                                                            ip: data.ip,
                                                            tracking_post_office: data.tracking_post_office,
                                                            post_office_date: null,
                                                            identified_problem: data.identified_problem,
                                                            necessary_procedure: data.necessary_procedure,
                                                            created_by_user_id: user?.id || null,
                                                            additional_item_received: data.additional_item_received,
                                                            cost_amount: data.cost_amount,
                                                            cost_freight: data.cost_freight,
                                                            cost_materials: data.cost_materials,
                                                            description_customer_problem: data.description_customer_problem,
                                                            software_version_id: data.software_version_id,
                                                            resolution_observation: data.resolution_observation,
                                                            local_pickup: data.local_pickup,
                                                            declaration_content: data.declaration_content,
                                                            service_invoice: data.service_invoice,
                                                            invoice_number_out: data.invoice_number_out,
                                                            ticket_status: ticketStatus,
                                                            integrator: integrator,
                                                            product: product,
                                                            not_charged: data.not_charged
                                                        });
                                                    }
                                                    await setFieldValue('technical_assistances', technicalAssistances);
                                                }}
                                            />}
                                            {rulesByTicketType.rule_attachment_client !== TicketLayoutTypeRule.NotVisible && <TaskAttachmentList
                                                attachments={values.attachments}
                                                downloadAttachment={downloadAttachment}
                                                openAttachmentDescriptionDialog={openAttachmentDescriptionDialog}
                                                removeAttachment={removeAttachment}
                                                setFieldValue={setFieldValue}
                                                addAttachment={addAttachment}
                                                type={AttachmentTaskType.Client}
                                                title={isInternal ? 'Anexos da solicitação' : 'Anexos do cliente'}
                                                isDisabled={!allow_edit_task_gen_att_cli}
                                            />}
                                            {rulesByTicketType.rule_attachment_analysis !== TicketLayoutTypeRule.NotVisible && <TaskAttachmentList
                                                attachments={values.attachments}
                                                downloadAttachment={downloadAttachment}
                                                openAttachmentDescriptionDialog={openAttachmentDescriptionDialog}
                                                removeAttachment={removeAttachment}
                                                setFieldValue={setFieldValue}
                                                addAttachment={addAttachment}
                                                type={AttachmentTaskType.Analysis}
                                                title={isInternal ? 'Anexos durante o desenvolvimento' : 'Anexos da análise'}
                                                moveAttachmentFromAnalysisToSolution={moveAttachmentFromAnalysisToSolution}
                                                enableMove={allow_edit_task_gen_att_cli}
                                            />}
                                            <Box marginTop={3} marginBottom={0} className='subtitleGradientBackgorund'>
                                                <Typography style={{ flex: 1 }} variant='subtitle2'>Resolução</Typography>
                                                {(isInternal && !(!allow_edit_task_resolution || !isFieldsMandatoryByTicketStatus)) ?
                                                    <OrangeButton
                                                        style={{ padding: '1px 10px' }}
                                                        onClick={async () => {
                                                            setLoading(true);
                                                            const ticketCauseResolutionList = await apiTicketCause.getList({ where: [['name', '=', 'Interna']] });
                                                            const ticketCauseResolution = ticketCauseResolutionList.length > 0 ? ticketCauseResolutionList[0] : null;
                                                            const ticketSolutionTypeResolutionList = await apiTicketSolutionType.getList({ where: [['name', '=', 'Definitiva']] });
                                                            const ticketSolutionTypeResolution = ticketSolutionTypeResolutionList.length > 0 ? ticketSolutionTypeResolutionList[0] : null;

                                                            await setFieldValue('ticket_cause_id', ticketCauseResolution?.id || null);
                                                            await setFieldValue('ticket_solution_type_id', ticketSolutionTypeResolution?.id || null);
                                                            await setFieldValue('solution', 'OK - Resolução automática');
                                                            setLoading(false);
                                                        }}
                                                        size='small'
                                                        type='button'
                                                        variant="contained">
                                                        Resolução automática: OK
                                                    </OrangeButton>
                                                    : null}
                                            </Box>
                                            <Divider style={{ marginBottom: 4 }} />
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <SearchEntity<TicketCause, 'id', 'name'>
                                                        name="ticket_cause_id"
                                                        entity="ticketCause"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Causa"
                                                        value={values.ticket_cause_id || null}
                                                        onChangeHandle={(_, v) => setFieldValue('ticket_cause_id', v)}
                                                        extraWhere={[['use_in_task', '=', true]]}
                                                        isClearable
                                                        isDisabled={!allow_edit_task_resolution || !isFieldsMandatoryByTicketStatus}
                                                        required={isFieldsMandatoryByTicketStatus}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                                                    <SearchEntity<TicketRootCause, 'id', 'name'>
                                                        name="ticket_root_cause_id"
                                                        entity="ticketRootCause"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Causa Raiz"
                                                        value={values.ticket_root_cause_id || null}
                                                        onChangeHandle={(_, v) => setFieldValue('ticket_root_cause_id', v)}
                                                        extraWhere={[['use_in_task', '=', true]]}
                                                        isClearable
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                                    <SearchEntity<TicketSolutionType, 'id', 'name'>
                                                        name="ticket_solution_type_id"
                                                        entity="ticketSolutionType"
                                                        valueField='id'
                                                        labelField="name"
                                                        label="Tipo de solução"
                                                        value={values.ticket_solution_type_id || null}
                                                        onChangeHandle={(_, v) => setFieldValue('ticket_solution_type_id', v)}
                                                        extraWhere={[['use_in_task', '=', true]]}
                                                        isClearable
                                                        isDisabled={!allow_edit_task_resolution || !isFieldsMandatoryByTicketStatus}
                                                        required={isFieldsMandatoryByTicketStatus}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <TextField
                                                        name="solution"
                                                        label={"Solução"}
                                                        margin="dense"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        value={values.solution}
                                                        onChange={handleChange}
                                                        error={!!errors.solution && !!dirty.solution}
                                                        helperText={!!errors.solution && !!dirty.solution && errors.solution}
                                                        disabled={!allow_edit_task_resolution || !isFieldsMandatoryByTicketStatus}
                                                        required={isFieldsMandatoryByTicketStatus}
                                                        inputProps={{
                                                            style: {
                                                                resize: 'vertical', overflow: 'auto', height: heightSolution, minHeight: heightSolution, maxHeight: 500
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {!!dirty.solution ?
                                                <Grid container alignItems="center" spacing={1}>
                                                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                                        <MaskedInput
                                                            mask={[/\d/, /\d/, ':', /[0-5]/, /\d/]}
                                                            name='time'
                                                            value={values.solution_time || ''}
                                                            onChange={(e) => {
                                                                setFieldValue('solution_time', e.target.value)
                                                            }}
                                                            style={{ width: 200 }}
                                                            render={(ref, props) => (
                                                                <TextField
                                                                    inputRef={ref}
                                                                    {...props}
                                                                    label={'Registrar tempo'}
                                                                    margin="dense"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    error={!!errors.solution_time && !!dirty.solution_time}
                                                                    helperText={!!errors.solution_time && !!dirty.solution_time && errors.solution_time}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                : null}
                                            {(allow_edit_task_resolution && isFieldsMandatoryByTicketStatus) ? <TextTemplateButtons task={item} page={isInternal ? 'taskInternal' : 'task'} disabled={!!values.solution_time} style={{ marginTop: 3 }} type={TextTemplateType.Conclusion} onClick={async (tt) => {
                                                await setFieldValue('solution', tt.template);
                                                if (rulesByTicketType.rule_attachment_solution !== TicketLayoutTypeRule.NotVisible && tt.system_attachments && tt.system_attachments.length > 0) {
                                                    tt.system_attachments.forEach(sa => {
                                                        if (!values.attachments.some(a => a.system_attachment_id === sa.id && a.type === AttachmentTaskType.Solution)) {
                                                            addAttachment(values.attachments, AttachmentTaskType.Solution, setFieldValue, sa.name, undefined, undefined, sa.id, sa);
                                                        }
                                                    });
                                                }
                                            }} /> : null}
                                            {rulesByTicketType.rule_attachment_solution !== TicketLayoutTypeRule.NotVisible && <TaskAttachmentList
                                                attachments={values.attachments}
                                                downloadAttachment={downloadAttachment}
                                                openAttachmentDescriptionDialog={openAttachmentDescriptionDialog}
                                                removeAttachment={removeAttachment}
                                                setFieldValue={setFieldValue}
                                                addAttachment={addAttachment}
                                                type={AttachmentTaskType.Solution}
                                                title={'Anexos da resolução'}
                                                isDisabled={!allow_edit_task_resolution}
                                            />}
                                            {rulesByTicketType.rule_checklist !== TicketLayoutTypeRule.NotVisible && <TaskChecklistList
                                                checklists={values.checklists}
                                                setFieldValue={setFieldValue}
                                                removeChecklist={removeChecklist}
                                                openAddChecklistDialog={openAddChecklistDialog}
                                                checkUncheckTaskChecklistItem={checkUncheckTaskChecklistItem}
                                                taskChecklists={taskChecklists}
                                                setTaskChecklistIsMandatory={setTaskChecklistIsMandatory}
                                                isActualTicketStatusClosed={isActualTicketStatusClosed}
                                                setTaskChecklistNotFilled={setTaskChecklistNotFilled}
                                            />}
                                            <TaskReferenceList
                                                references={values.references}
                                                removeReference={removeReference}
                                                openAddTaskReferenceDialog={openAddReferenceDialog}
                                                setFieldValue={setFieldValue}
                                                referenced_by={item?.referenced_by || []}
                                            />
                                        </> : null}
                                        <ProjectQuickCreateFormDialog
                                            open={projectCreateDialogOpen}
                                            onCancel={() => setProjectCreateDialogOpen(false)}
                                            onSubmit={(data) => submitProjectCreateDialog(data, setFieldValue)}
                                            observersOptions={observers}
                                            initialValues={projectCreateInitialValues}
                                            loading={isSavingProject}
                                        />
                                        <ChecklistFormDialog
                                            addChecklistDialogOpen={addChecklistDialogOpen}
                                            checklists={values.checklists}
                                            onCancel={() => closeAddChecklistDialog()}
                                            onSubmit={addChecklist}
                                            setFieldValue={setFieldValue}
                                        />
                                        <TaskReferenceFormDialog
                                            addReferenceDialogOpen={addReferenceDialogOpen}
                                            references={values.references}
                                            onCancel={() => closeAddReferenceDialog()}
                                            onSubmit={addReference}
                                            setFieldValue={setFieldValue}
                                            task_id={item?.id}
                                            referenced_by={item?.referenced_by || []}
                                        />
                                        <TaskAttachmentDescriptionFormDialog
                                            attachmentDescriptionDialogOpen={attachmentDescriptionDialogOpen}
                                            onCancel={() => closeAttachmentDescriptionDialog()}
                                            onSubmit={(description) => submitAttachmentDescriptionDialog(setFieldValue, values.attachments, description, attachmentsEditingIdx)}
                                            attachments={values.attachments}
                                            attachmentsEditingIdx={attachmentsEditingIdx}
                                        />
                                        <CommentFormDialog
                                            commentDialogOpen={commentDialogOpen}
                                            onCancel={() => closeCommentDialog()}
                                            onSubmit={(comment, isPublic, time, assigned_users, attachments, transfer_task, transfer_task_user_id, reminder_date, prod_amount, prod_amount_problem, send_comment_to_approver, notify_others_users) =>
                                                submitCommentDialog(setFieldValue, values.comments, comment, isPublic, time, assigned_users, attachments, values.attachments, undefined,
                                                    transfer_task, transfer_task_user_id, reminder_date, prod_amount, prod_amount_problem, send_comment_to_approver, notify_others_users)}
                                            allowPublicComment={(!isInternal && user?.allow_create_public_observation) || (isInternal && item?.register_origin === 'taskInternalProductEngineering')}
                                            useTime={true}
                                            useAssignedToUser={true}
                                            enableAttachments={rulesByTicketType.rule_comment_attachment !== TicketLayoutTypeRule.NotVisible}
                                            showTextTemplates={true}
                                            isInternal={isInternal}
                                            task={item}
                                            relatedUsers={relatedUsers}
                                            allowSelfAssign={true}
                                            enableReminder={rulesByTicketType.rule_comment_reminder !== TicketLayoutTypeRule.NotVisible}
                                            page={isInternal ? 'taskInternal' : 'task'}
                                            showUserVacation
                                            ruleProdAmount={rulesByTicketType.rule_quantity_to_be_produced}
                                            ticketTypeApprovers={ticketTypeApprovers}
                                            enableSystemAttachments
                                        />
                                        <ReminderFormDialog
                                            reminderDialogOpen={reminderDialogOpen.open}
                                            days={reminderDialogOpen.days}
                                            onCancel={() => closeReminderDialog()}
                                            onSubmit={(comment, reminder_date, reminderUsers) => submitReminderDialog(setFieldValue, values.comments, comment, reminder_date, reminderUsers)}
                                            relatedUsers={relatedUsers}
                                        />
                                        <FirmwareFormDialog
                                            firmwareDialogOpen={firmwareDialogOpen}
                                            onCancel={() => closeFirmwareDialog()}
                                            onSubmit={(data, software) => submitFirmwareDialog(setFieldValue, values.comments, data, software)}
                                            firmwares={newFirmwares}
                                        />
                                        <TaskCloseConfirmationDialog
                                            open={closeConfirmationOpen}
                                            isInternal={isInternal}
                                            values={values}
                                            onCancel={handleCloseConfirmationCancel}
                                            onConfirm={handleCloseConfirmationConfirm}
                                            iaSuggestions={iaSuggestions}
                                            iaSuggestionsLoading={iaSuggestionsLoading}
                                            onRequestIaSuggestions={handleIaSuggestionsReload}
                                        />
                                    </>
                                );
                            }}
                        </Form>
                        {rulesByTicketType.ticket_type_id ? <>
                            <Box zIndex={2} marginTop={3} marginBottom={4} borderBottom={`1px solid ${theme.palette.divider}`} display="flex" position={'sticky'} top={'-4px'} bgcolor={theme.palette.background.default}>
                                <Typography variant='subtitle2' style={{ flex: 1 }} className="subtitleGradientBackgorund">Histórico do atendimento</Typography>
                                <Tooltip placement="top" title={'Adicionar lembrete automático para daqui 3 dias'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Adicionar lembrete automático para daqui 3 dias'}
                                        onClick={() => openReminderDialog(3)}
                                        disabled={!!isDisableComment}
                                    >
                                        <Filter3Icon />
                                    </IconButton>
                                </Tooltip>
                                <Divider orientation="vertical" variant="middle" flexItem />
                                <Tooltip placement="top" title={'Adicionar lembrete automático para daqui 7 dias'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Adicionar lembrete automático para daqui 7 dias'}
                                        onClick={() => openReminderDialog(7)}
                                        disabled={!!isDisableComment}
                                    >
                                        <Filter7Icon />
                                    </IconButton>
                                </Tooltip>
                                <Divider orientation="vertical" variant="middle" flexItem />
                                <Tooltip placement="top" title={'Adicionar lembrete'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Adicionar lembrete'}
                                        onClick={() => openReminderDialog(null)}
                                        disabled={!!isDisableComment}
                                    >
                                        <NotificationAddIcon />
                                    </IconButton>
                                </Tooltip>
                                <Divider orientation="vertical" variant="middle" flexItem />
                                {item?.comments && item?.comments.filter(c => c.user?.name === 'LanzaBot' && c.comment_task_users && (c.comment_task_users.filter(cc => cc.resolved_at && cc.user_id === user?.id).length > 0 || (c.comment_task_users.filter(cc => cc.resolved_at).length === c.comment_task_users.length && c.comment_task_users.length > 0))).length > 0 ? <>
                                    <Tooltip placement="top" title={'Comentários LanzaBot concluídos'}>
                                        <IconButton
                                            size='small'
                                            color="inherit"
                                            aria-label={'Comentários LanzaBot concluídos'}
                                            onClick={() => setShowLanzaBotConclued(!showLanzaBotConclued)}
                                            style={{ opacity: showLanzaBotConclued ? 1 : 0.3 }}
                                        >
                                            <SmartToyIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Divider orientation="vertical" variant="middle" flexItem />
                                </> : null}
                                {item && <Tooltip placement="top" title={'Análise do LanzaBot'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Análise do LanzaBot'}
                                        onClick={async () => {
                                            const commentsResume = await api.resumeTaskGemini(item.id);
                                            if (commentsResume) {
                                                alertDialog('Análise do LanzaBot', <Markdown>{commentsResume}</Markdown>);
                                            }
                                        }}
                                    >
                                        <AssistantIcon />
                                    </IconButton>
                                </Tooltip>}
                                <Tooltip placement="top" title={'Adicionar firmware'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Adicionar firmware'}
                                        onClick={() => openFirmwareDialog()}
                                        disabled={!!isDisableComment}
                                    >
                                        <MemoryIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip placement="top" title={'Adicionar comentário'}>
                                    <IconButton
                                        size='small'
                                        color="inherit"
                                        aria-label={'Adicionar comentário'}
                                        onClick={() => openCommentDialog()}
                                        disabled={!!isDisableComment}
                                    >
                                        <ChatIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <TicketHistory
                                showTotalTimeCounter={true}
                                key={item?.id}
                                type="task"
                                id={item?.id}
                                comments={item?.comments?.filter(c => c.type === CommentTaskType.PreService) || []}
                                ticketHistoryEventListener={eventEmmiter}
                                hideLanzaBotConclued={!showLanzaBotConclued}
                                user={user}
                                showAssignedUsers={true}
                                showGeneratedTaskCreation
                                task={item}
                                isInternal={isInternal}
                                showGitIcon
                            />
                        </> : null}
                        <PopupWrapper
                            title={"Observações de chamado do cliente final"}
                            dismiss={() => setFinalCustomerTaskObservationDialogOpen(false)}
                            maxWidth="md"
                            fullWidth
                            show={finalCustomerTaskObservationDialogOpen}
                        >
                            <Typography variant='body2' style={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{finalCustomerTaskObservation}</Typography>
                        </PopupWrapper>
                        <PopupWrapper
                            title={"Observações de chamado do integrador"}
                            dismiss={() => setIntegratorTaskObservationDialogOpen(false)}
                            maxWidth="md"
                            fullWidth
                            show={integratorTaskObservationDialogOpen}
                        >
                            <Typography variant='body2' style={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{integratorTaskObservation}</Typography>
                        </PopupWrapper>
                        <PopupWrapper
                            title={"Contratos do Cliente"}
                            dismiss={() => setFinalCustomerContractsDialogOpen(false)}
                            maxWidth="md"
                            fullWidth
                            show={finalCustomerContractsDialogOpen}
                        >
                            {finalCustomerContracts.length === 0 ? (
                                <Box
                                    sx={{
                                        p: 3,
                                        textAlign: 'center',
                                        borderLeft: '4px solid #f44336',
                                        borderRadius: 1,
                                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(244,67,54,0.1)' : 'rgba(244,67,54,0.05)',
                                    }}
                                >
                                    <Typography variant='body1' sx={{ color: '#f44336', fontWeight: 500 }}>
                                        Este cliente não possui contratos cadastrados.
                                    </Typography>
                                </Box>
                            ) : (
                                <Box>
                                    {finalCustomerContracts.map((contract) => {
                                        const expiresAt = contract.expires_at ? moment(contract.expires_at) : null;
                                        const isExpired = expiresAt ? expiresAt.isBefore(moment(), 'day') : false;
                                        const isActive = contract.status === FinalCustomerContractStatus.Ativo && !contract.blocked && !isExpired;
                                        const statusColor = isActive ? '#4caf50' : (contract.blocked || isExpired ? '#f44336' : '#ff9800');

                                        return (
                                            <Box
                                                key={contract.id}
                                                sx={{
                                                    p: 2,
                                                    mb: 2,
                                                    borderLeft: `4px solid ${statusColor}`,
                                                    borderRadius: 1,
                                                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                                                    boxShadow: 1
                                                }}
                                            >
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={6} sm={3}>
                                                        <Typography variant='caption' color="textSecondary" display="block">Linha de Produto</Typography>
                                                        <Typography variant='body2' fontWeight={500}>{productLineTitle(contract.product_line)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Typography variant='caption' color="textSecondary" display="block">Tipo de Serviço</Typography>
                                                        <Typography variant='body2' fontWeight={500}>{serviceTypeTitle(contract.service_type)}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant='caption' color="textSecondary" display="block">Status</Typography>
                                                        <Chip
                                                            size="small"
                                                            label={isActive ? 'Ativo' : (contract.blocked ? 'Bloqueado' : (isExpired ? 'Vencido' : 'Inativo'))}
                                                            sx={{
                                                                backgroundColor: statusColor,
                                                                color: '#fff',
                                                                fontWeight: 600,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant='caption' color="textSecondary" display="block">Início</Typography>
                                                        <Typography variant='body2'>{contract.initiated_at ? moment(contract.initiated_at).format('DD/MM/YYYY') : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Typography variant='caption' color="textSecondary" display="block">Vencimento</Typography>
                                                        <Typography variant='body2' sx={{ color: isExpired ? 'error.main' : 'inherit', fontWeight: isExpired ? 600 : 400 }}>
                                                            {expiresAt ? expiresAt.format('DD/MM/YYYY') : '-'}
                                                        </Typography>
                                                    </Grid>
                                                    {contract.reason && (
                                                        <Grid item xs={12}>
                                                            <Typography variant='caption' color="textSecondary" display="block">Motivo</Typography>
                                                            <Typography variant='body2'>{contract.reason}</Typography>
                                                        </Grid>
                                                    )}
                                                    {contract.description && (
                                                        <Grid item xs={12}>
                                                            <Typography variant='caption' color="textSecondary" display="block">Descrição</Typography>
                                                            <Typography variant='body2'>{contract.description}</Typography>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            )}
                        </PopupWrapper>
                        {/* if (rulesByTicketType.rule_attachment_analysis !== TicketLayoutTypeRule.NotVisible ||
                rulesByTicketType.rule_attachment_solution !== TicketLayoutTypeRule.NotVisible ||
                rulesByTicketType.rule_attachment_client !== TicketLayoutTypeRule.NotVisible) { */}
                        <PopupWrapper
                            title={"Você deseja adicionar este(s) anexo(s) como:"}
                            show={attachmentPasteDialogOpen}
                        >
                            <Box>
                                <ErrorButton
                                    size='small'
                                    variant="contained"
                                    onClick={() => {
                                        setAttachmentPasteDialogOpen(false);
                                        setClipboardDataTask(null);
                                    }}
                                >
                                    Cancelar
                                </ErrorButton>
                                {allow_edit_task_gen_att_cli && rulesByTicketType.rule_attachment_client !== TicketLayoutTypeRule.NotVisible ? <DefaultButton
                                    size='small'
                                    type='button'
                                    variant="contained"
                                    style={{ marginLeft: 10 }}
                                    onClick={() => onPasteHandlerContinue(clipboardDataTask, 'attachment-task-1')}
                                >
                                    {isInternal ? 'Solicitação' : 'Cliente'}
                                </DefaultButton> : null}
                                {rulesByTicketType.rule_attachment_analysis !== TicketLayoutTypeRule.NotVisible ? <DefaultButton
                                    size='small'
                                    type='button'
                                    variant="contained"
                                    onClick={() => onPasteHandlerContinue(clipboardDataTask, 'attachment-task-2')}
                                    style={{ marginLeft: 10 }}
                                >
                                    {isInternal ? 'Desenvolvimento' : 'Análise'}
                                </DefaultButton> : null}
                                {allow_edit_task_resolution && rulesByTicketType.rule_attachment_solution !== TicketLayoutTypeRule.NotVisible ? <DefaultButton
                                    size='small'
                                    type='button'
                                    variant="contained"
                                    onClick={() => onPasteHandlerContinue(clipboardDataTask, 'attachment-task-3')}
                                    style={{ marginLeft: 10 }}
                                >
                                    Resolução
                                </DefaultButton> : null}
                            </Box>
                        </PopupWrapper>
                    </Grid >
                </Grid>
            </PanelBodyFormContent>
        </Panel>
    )
}